<script setup>
import { onMounted, ref, reactive, computed, getCurrentInstance } from 'vue';
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated.vue';
import { Head, Link, usePage } from '@inertiajs/inertia-vue3';
import PremiumTabs from '@/Components/PremiumTabs.vue';
import PremiumPageHeader from '@/Components/PremiumPageHeader.vue';
import { Icon } from '@iconify/vue';
import BaseIcon from "@/Components/BaseIcon.vue";
import CardBoxModal from "@/Components/CardBoxModal.vue";
import {
    mdiEye, mdiCog, mdiArrowUpCircle, mdiArrowDownCircle, mdiArrowDownBold, mdiClipboardEdit, mdiCashPlus, mdiPlusCircle, mdiInformationOutline, mdiChevronRight,
    mdiCloud
} from "@mdi/js";
import VueCal from "vue-cal";
import 'vue-cal/dist/vuecal.css'
import CardBox from "@/Components/CardBox.vue";
import TableAdvanced from "@/Components/TableAdvanced.vue";
import CardBoxComponentEmpty from '@/Components/CardBoxComponentEmpty.vue';
import CardBoxComponentLoad from '@/Components/CardBoxComponentLoad.vue';
import BaseButtons from "@/Components/BaseButtons.vue";
import BaseButton from "@/Components/BaseButton.vue";
import CardBoxWidget from "@/Components/CardBoxWidget.vue";
import SectionTitleLineWithButton from "@/Components/SectionTitleLineWithButton.vue";
//import SectionTitleLineWithButtonUnens from "@/Components/SectionTitleLineWithButtonUnens.vue";// <-- Cambios para agregar más contenido
import LineChart from "@/Components/Charts/LineChart.vue";
import BarChart from "@/Components/Charts/BarChart.vue";
import NotificationAlert from "@/Components/NotificationAlert.vue";
import BreezeDropdown from '@/Components/Dropdown.vue';
import BreezeDropdownLink from '@/Components/DropdownLink.vue';
//import RadarChart from "@/Components/Charts/RadarChart.vue";// Example <-- cambiar a sólo RadarChart y no Example
// Pruebas
//import * as chartConfig from "@/Components/Charts/chart.config.js";

// Formulario
import BreezeLabel from '@/Components/Label.vue';
import BreezeInput from '@/Components/Input.vue';

// Section Configuration
import FormField from "@/Components/FormField.vue";
import FormControl from "@/Components/FormControl.vue";
import BreezeValidationErrors from '@/Components/ValidationErrors.vue';
import { Inertia } from '@inertiajs/inertia';
import VueSelect from "vue3-select-component";

const props = defineProps({
    actioncontrol: {
        type: String,
        default: 'view'
    },
    titleup: String,
    classrooms: Object,
    classroomsTutor: Object,
    classroomsCoord: Object,
    events: Array,
    isAdmin: Boolean,
    isAdminCoord: Boolean,
    isCoord: Boolean,
    isTutor: Boolean,
    isPsico: Boolean,
    isSecre: Boolean,
    coursesComp: Array,
    anioEscolar: Number,
    anioActual: Number,
    students: Array,
    allStudents: Array,
    studentBecados: Array,
    studentCompromisoPago: Array,
    studentPensionPref: Array,
    orderPtePagos: Number,
    orderPtePagosRet: Number,
    orderFacturado: Number,
    orderNoFacturado: Number,
    factureAceptado: Number,
    factureEnviado: Number,
    factureObservado: Number,
    confConst: Object,
    studentsPtePagosRet: Number,
    studentsDisabledAcces: Number,
    listStudentsPtePagosRet: Array,
    arrayDeudores: Array,
    arrayDeudoresCol: Array,
    userParamDeudores: Object,
    message: String,
    formatoTxt: Number,
    debtorsByLevel: Array,
    financialSummary: Object,
    conceptDebt: Array,
    debtorsByLevelAndConcept: Array
});

const action = ref(props.actioncontrol)
//const tab = ref((props.isAdmin ? 0 : 4))
const tab = ref(0)
const subtab = ref(0)

const instance = getCurrentInstance(); // Recuperar valores globales
const configGlobal = instance.appContext.config.globalProperties.confGlobal; // <-- Aqui se usa configGlobal en el template es confGlobal

//console.log('El valor de facturación ya cargó y es:', configGlobal.value.FINANCIERA_USE_FACTURACION);

const tabsMenu = computed(() => [
    { id: 0, label: 'Dashboard', icon: 'tabler:layout-dashboard', show: props.isAdmin || props.isCoord || props.isAdminCoord || props.isSecre },
    { id: 1, label: 'Estado de cuenta', icon: 'tabler:report-money', show: props.isAdmin || props.isAdminCoord || props.isSecre },
    { id: 6, label: 'Facturación', icon: 'tabler:file-invoice', show: configGlobal.value.FINANCIERA_USE_FACTURACION == 1 && (props.isAdmin || props.isSecre) },
    { id: 5, label: 'Contabilidad', icon: 'tabler:calculator', show: configGlobal.value.MAIN_FEATURES_LEVEL >= 1 && configGlobal.value.FINANCIERA_USE_FACTURACION == 1 && (props.isAdmin || props.isSecre) },
    { id: 2, label: 'Procesar pagos', icon: 'tabler:cash', show: props.isAdmin },
    { id: 4, label: 'Cobranzas', icon: 'tabler:wallet', show: true },
    { id: 3, label: 'Configuración', icon: 'tabler:settings', show: props.isAdmin },
]);

const handleTabChange = (t) => {
    tab.value = t.id;
    if (t.id !== 5) cleanVal();
    
    if (t.id === 1) listarOrdenPago();
    if (t.id === 6) listarFacture();
    if (t.id === 4) reloadProps(['arrayDeudores', 'orderPtePagos', 'orderPtePagosRet']);
};

if (action.value == 'view_estados_cuenta') {
    tab.value = 1
}

const anioSearch = ref(null)

const selectedYearDebtors = ref(new URLSearchParams(window.location.search).get('anioSearch') ? parseInt(new URLSearchParams(window.location.search).get('anioSearch')) : props.anioEscolar)
const levelDebtorsData = ref(props.debtorsByLevel)
const financialSummaryData = ref(props.financialSummary)
const conceptDebtData = ref(props.conceptDebt)
const levelAndConceptDebtorsData = ref(props.debtorsByLevelAndConcept)

const totalDebtors = computed(() => {
    if (!levelDebtorsData.value) return 0;
    return levelDebtorsData.value.reduce((sum, item) => sum + parseInt(item.cant_deudores || 0), 0);
});

const totalPendingAmount = computed(() => {
    if (!levelDebtorsData.value) return 0;
    return levelDebtorsData.value.reduce((sum, item) => sum + parseFloat(item.monto_pendiente || 0), 0);
});

const pivotedDebtorsData = computed(() => {
    if (!levelAndConceptDebtorsData.value || !levelAndConceptDebtorsData.value.length) {
        return { concepts: [], rows: [] };
    }

    const conceptsSet = new Set();
    levelAndConceptDebtorsData.value.forEach(item => {
        if (item.concept_label) {
            conceptsSet.add(item.concept_label);
        }
    });
    const concepts = Array.from(conceptsSet).sort();

    const levelMap = {};
    levelAndConceptDebtorsData.value.forEach(item => {
        const key = item.level_ref;
        if (!levelMap[key]) {
            levelMap[key] = {
                level_ref: item.level_ref,
                level_label: item.level_label,
                concepts: {}
            };
        }
        levelMap[key].concepts[item.concept_label] = {
            cant_deudores: parseInt(item.cant_deudores || 0),
            monto_pendiente: parseFloat(item.monto_pendiente || 0)
        };
    });

    const rows = Object.values(levelMap).map(row => {
        const levelTotal = levelDebtorsData.value?.find(ld => ld.level_ref === row.level_ref) || { cant_deudores: 0, monto_pendiente: 0 };
        const total_deudas_totales = Object.values(row.concepts).reduce((sum, item) => sum + parseInt(item.cant_deudores || 0), 0);
        return {
            ...row,
            total_deudores: parseInt(levelTotal.cant_deudores || 0),
            total_deudas_totales: total_deudas_totales,
            total_monto: parseFloat(levelTotal.monto_pendiente || 0)
        };
    });

    const orderedRefs = levelDebtorsData.value?.map(ld => ld.level_ref) || [];
    rows.sort((a, b) => orderedRefs.indexOf(a.level_ref) - orderedRefs.indexOf(b.level_ref));

    return { concepts, rows };
});

const pivotedConceptTotals = computed(() => {
    const totals = {};
    const data = pivotedDebtorsData.value;
    if (!data || !data.concepts.length) return totals;

    data.concepts.forEach(concept => {
        totals[concept] = {
            cant_deudores: 0,
            monto_pendiente: 0
        };
        data.rows.forEach(row => {
            if (row.concepts[concept]) {
                totals[concept].cant_deudores += row.concepts[concept].cant_deudores;
                totals[concept].monto_pendiente += row.concepts[concept].monto_pendiente;
            }
        });
    });

    return totals;
});

const changeYearAll = () => {
    Inertia.get(window.location.pathname, { anioSearch: selectedYearDebtors.value }, {
        preserveState: true,
        preserveScroll: true,
        onSuccess: () => {
            levelDebtorsData.value = props.debtorsByLevel;
            financialSummaryData.value = props.financialSummary;
            conceptDebtData.value = props.conceptDebt;
            levelAndConceptDebtorsData.value = props.debtorsByLevelAndConcept;
        }
    });
    listarChartOrdenes();
};

//console.log(props.listStudentsPtePagosRet)

const pinSecurity = ref('')
const msg1 = ref('')
const navigatorVersion = ref('')
const navigatorName = ref('')
onMounted(() => {
    //console.log(msg)
    // msg1.value = msg
    if (action.value == 'view_estados_cuenta') {
        listarOrdenPago()
    }
    listarChartOrdenes()
    navigatorVersion.value = navigator.appVersion
    navigatorName.value = navigator.appName
});

const chartOrdenes = ref(null)// <-- Estaba en Array y generaba error con un labels y datasets adicionales
/* onMounted(() => {
    listarChartCalification()
}); */
const chartPendientes = ref(null)
const listarChartOrdenes = () => {
    let url = '/payementOrder/grafica?anioSearch=' + selectedYearDebtors.value;

    axios.get(url).then(function (response) {
        let respuesta = response.data;
        chartOrdenes.value = respuesta.chartCuentasTodas
        chartPendientes.value = respuesta.chartPendientes
        console.log(chartOrdenes.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const arrayListDeudoresCol = ref(props.arrayDeudoresCol)
const arrayListDeudores = ref(props.arrayDeudores)
const listarDeudores = () => {
    //let url = '/caficiation/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    let url = '/payementOrder/inicio?' + 'listardeudores=1' + '&anioSearch=' + anioSearch.value;

    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayListDeudoresCol.value = respuesta.listardeudorescol
        arrayListDeudores.value = respuesta.listardeudores
        //console.log(arrayListDeudores.value);
    }).catch(function (error) {
        console.log(error);
    });
}
// Info de calendar
const selectedEvent = ref({})
const showDialog = ref(false)
const pruebaevents = [
    { id: 1, start: '2023-04-19 12:00', end: '2023-04-19 13:00', title: 'Más trabajo, está bien 1', content: '', contentFull: 'My shopping list is rather long:<br><ul><li>Avocados</li><li>Tomatoes</li><li>Potatoes</li><li>Mangoes</li></ul>', class: 'leisure', deletable: 1 },
    { id: 2, start: '2023-04-20 12:00', end: '2023-04-23 17:00', title: 'Más trabajo, está bien 2', content: 'es mejor que halla más trabajo 2', contentFull: 'My shopping list is rather long:<br><ul><li>Avocados</li><li>Tomatoes</li><li>Potatoes</li><li>Mangoes</li></ul>', class: 'sport', split: 1 },
    { id: 3, start: '2023-04-20 12:00', end: '2023-04-21 14:00', title: 'Más trabajo, está bien 3', content: 'es mejor que halla más trabajo 3', contentFull: 'My shopping list is rather long:<br><ul><li>Avocados</li><li>Tomatoes</li><li>Potatoes</li><li>Mangoes</li></ul>', class: 'leisure', allday: 1 },
    { id: 4, start: '2023-04-17 12:00', end: '2023-04-18 13:00', title: 'Más trabajo, está bien 4', content: 'es mejor que halla más trabajo 4', contentFull: 'My shopping list is rather long:<br><ul><li>Avocados</li><li>Tomatoes</li><li>Potatoes</li><li>Mangoes</li></ul>', class: 'sport', resizable: 1 }
]
const onEventClick = (event, e) => {
    selectedEvent.value = event
    showDialog.value = true
    // Prevent navigating to narrower view (default vue-cal behavior).
    e.stopPropagation()
}

// Infor de Aulas y curso   
const data = {
    "estudiante_curso": [
        { "id": 1, "codigo": "2205", "name": "Primero - B", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "" },
        { "id": 2, "codigo": "2205-BIOLO", "name": "Tercero - D", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "última fecha de entrega de trabajos este viernes ..." },
        { "id": 3, "codigo": "2205-FISICA", "name": "Cuarto - A", "tarea": "2/2 (FL 12/10/2022)", "anuncio": "Entrega de trabajo grupal hasta el martes" },
        { "id": 4, "codigo": "2205-QUIMICA", "name": "Segundo - A", "tarea": "4/4 (FL 12/10/2022)", "anuncio": "" },
        { "id": 5, "codigo": "2205-HISTO", "name": "Primero - C", "tarea": "2/4 (FL 12/10/2022)", "anuncio": "" },
    ]
};

const viewCourses = ref([])
const viewStudents = ref([])

/* if (props.isAdmin) {
    tab.value = 0
} */

/* const arrayPensionPreferencial = ref([])
const arrayBecados = ref([])
const listarStadisticOrder = () => {

} */

const arrayFacture = ref([]);
const arrayFactureCol = ref([]);
const userParamFacture = ref(null);
const listarFacture = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/facture';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayFacture.value = respuesta.datalist;
        arrayFactureCol.value = respuesta.columnas;
        userParamFacture.value = respuesta.userParam;
        console.log('Facture ' + props.message);
        //console.log(arrayOrdenPago.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const arrayOrdenPago = ref([]);
const arrayOrdenPagoCol = ref([]);
const userParamOrdenPago = ref(null);
const listarOrdenPago = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/payementOrder';
    if (tab.value == 2 && idStudentOrder.value > 0) url = '/payementOrder' + '?id_student_order=' + idStudentOrder.value;

    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayOrdenPago.value = respuesta.datalist;
        arrayOrdenPagoCol.value = respuesta.columnas;
        userParamOrdenPago.value = respuesta.userParam;
        console.log('OrdenaPago ' + props.message);
        //console.log(arrayOrdenPago.value);
    }).catch(function (error) {
        console.log(error);
    });
}

const showCrearOrden = ref(false)
const showUpdateOrden = ref(false)
const orderAnio = ref(props.anioEscolar)

const qtyYearsBackOrder = computed(() => {
    const val = configGlobal.value?.FINANCIERA_ORDER_PAYMENT_QTY_YEAR_OLDS_CREATE;
    const parsed = parseInt(val);
    return !isNaN(parsed) && parsed >= 0 ? parsed : 3;
});

const availableOrderYears = computed(() => {
    const baseYear = parseInt(props.anioEscolar);
    const years = [];
    for (let i = qtyYearsBackOrder.value; i >= 1; i--) {
        years.push(baseYear - i);
    }
    years.push(baseYear);
    years.push(baseYear + 1);
    return years;
});
const matriculaFVencimiento = ref('')
const order03 = ref(false)
const order04 = ref(false)
const order05 = ref(false)
const order06 = ref(false)
const order07 = ref(false)
const order08 = ref(false)
const order09 = ref(false)
const order10 = ref(false)
const order11 = ref(false)
const order12 = ref(false)
const order13 = ref(false)

const showCrearOrdenVarios = ref(false)
const tipoDeOrder = ref(0)
const idOrderOrigen = ref(0)
const fechaEmision = ref()
const fechaVencimiento = ref('')
const orderVariosLabel = ref('')
const orderVariosAmount = ref(0)
const errorOrderVarios = ref('')
const miniloading = ref(false)

//fechaEmision.value = new Date().toLocaleDateString('en-CA')
//fechaVencimiento.value = new Date().toLocaleDateString('en-CA')

/* const formOrdenPago = {
    id_student: 0,
    //ref: '',
    periodo: '',
    label: '',
    fecha_emision: props.nowDate,
    fecha_vencimiento: '',
    //title: props.course.label + ' (A)',
    title: '(A)',
    content: '',
    
    percent: -1

}; */
const idStudentOrder = ref(0);
const iniciarOrdenPago = async (matricula = 0, pInicial = 0,) => {

    const newArr = [];
    const newArrPeriodo = [];
    const arr = props.students
    if (idStudentOrder.value > 0) {
        newArr.push({
            id_student: idStudentOrder.value,

        });
    } else {
        arr.forEach((student) => {
            newArr.push({
                id_student: student.id,
                //id_course: formDiario.id_course,
                /* total_ttc: formDiario.id_classroom,
                asistencia: formDiario.asistencia,
                title: formDiario.title,
                content: formDiario.content,
                fecha: formDiario.fecha,
                percent: formDiario.percent */
            });
        });
    }

    // Periodos
    if (order03.value) {
        newArrPeriodo.push('03')
    }
    if (order04.value) {
        newArrPeriodo.push('04')
    }
    if (order05.value) {
        newArrPeriodo.push('05')
    }
    if (order06.value) {
        newArrPeriodo.push('06')
    }
    if (order07.value) {
        newArrPeriodo.push('07')
    }
    if (order08.value) {
        newArrPeriodo.push('08')
    }
    if (order09.value) {
        newArrPeriodo.push('09')
    }
    if (order10.value) {
        newArrPeriodo.push('10')
    }
    if (order11.value) {
        newArrPeriodo.push('11')
    }
    if (order12.value) {
        newArrPeriodo.push('12')
    }
    if (order13.value) {
        newArrPeriodo.push('13')
    }

    //let ruta = 'payementOrder-registrar'
    if (newArr.length) {

        let formOrdenPago = {
            'anioOrden': orderAnio.value,
            'arrayPeriodo': newArrPeriodo,
            'arrayData': newArr,
            'matriculaFVencimiento': matriculaFVencimiento.value
        };

        let url = '/payementOrder/registrar';
        miniloading.value = true
        await axios.post(url, formOrdenPago).then((response) => {
            let respuesta = response.data;
            //arrayOrdenPago.value = respuesta.datalist;
            //arrayOrdenPagoCol.value = respuesta.columnas;
            if (respuesta.success) {
                //alertaSubida.value = 1;
                //mensajes.value = 'Total registros : '+(data.total-1)+'\nRegistrados : '+data.registered+'\nActualizados : '+data.updated;
                //limpiarVal(5000);
                //messageAlert.value = respuesta.data.message
                showAlert(respuesta.message, 'success', 4)
                //console.log(response)

            } else {
                showAlert(respuesta.message, 'danger', 16)
                //alertaSubida.value = 2;
                //mensajes.value = respuesta.data.message;
                //limpiarVal(3000);

            }

            console.log('Hola ok');
            //console.log(arrayOrdenPago.value);
        }).catch((error) => {
            console.log(error);

        });
        miniloading.value = false

        //console.log(newArr)
        //if (!props.debugDisableRefreshInertia) Inertia.reload({ only: ['diarios']})

    }

}

const iniciarOrdenPagoVarios = async () => {

    let id_student = idStudentOrder.value
    let fecha_emision = fechaEmision.value
    let fecha_vencimiento = fechaVencimiento.value
    let label = orderVariosLabel.value
    let amount = orderVariosAmount.value
    let typeOrder = tipoDeOrder.value
    let idOrderOrigin = idOrderOrigen.value

    if (id_student && label && amount) {
        let formOrdenPago = {
            'id_student': id_student,
            'fecha_emision': fecha_emision,
            'fecha_vencimiento': fecha_vencimiento,
            'label': label,
            'amount': amount,
            'tipo_de_order': typeOrder,
            'id_order_origen': idOrderOrigin
        };

        let url = '/payementOrder/registrarvarios';
        miniloading.value = true
        await axios.post(url, formOrdenPago).then((response) => {
            let respuesta = response.data;
            //arrayOrdenPago.value = respuesta.datalist;
            //arrayOrdenPagoCol.value = respuesta.columnas;
            if (respuesta.success) {
                showAlert(respuesta.message, 'success', 4)
                cleanVal()
                if (typeOrder == 1) arrayOrdenPago.value = []
                //console.log(response)
            } else {
                showAlert(respuesta.message, 'danger', 16)
            }
            console.log('response payement varios');
            //console.log(arrayOrdenPago.value);
        }).catch((error) => {
            console.log(error);

        });
        miniloading.value = false
    } else {
        errorOrderVarios.value = 'Error'
    }

}

const cleanVal = () => {

    showCrearOrden.value = false

    showUpdateOrden.value = false
    order03.value = false
    order04.value = false
    order05.value = false
    order06.value = false
    order07.value = false
    order08.value = false
    order09.value = false
    order10.value = false
    order11.value = false
    order12.value = false
    order13.value = false
    messageLastAction.value = ''
    messageError.value = ''
    idStudentOrder.value = 0
    pinSecurity.value = ''

    tipoDeOrder.value = 0
    idOrderOrigen.value = 0
    showCrearOrdenVarios.value = false
    orderVariosLabel.value = ''
    orderVariosAmount.value = 0
    errorOrderVarios.value = ''
    //fechaEmision.value = new Date().toLocaleDateString('es-PE')
    //fechaVencimiento.value = new Date().toLocaleDateString('es-PE')
}

// Sección diario de asistencia
const arrayDiario = ref([]);
const arrayDiarioCol = ref([]);
const listarDiario = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/diario';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayDiario.value = respuesta.diarios;
        arrayDiarioCol.value = respuesta.columnas;
        //console.log(arrayDiario.value);
    }).catch(function (error) {
        console.log(error);
    });
}

// Sección califaciones
const arrayCalification = ref([]);
const arrayCalificationCol = ref([]);
const arrayCalificationCourses = ref([]);
const listarCalification = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/calification';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayCalification.value = respuesta.datalist;
        arrayCalificationCol.value = respuesta.columnas;
        arrayCalificationCourses.value = respuesta.select1;
        //console.log(arrayCalification.value);
    }).catch(function (error) {
        console.log(error);
    });
}

// Sección Admisión puntajes
const arrayAdmisionPuntaje = ref([]);
const arrayAdmisionPuntajeCol = ref([]);
const listarAdmisionPuntaje = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/admisionpuntaje';
    axios.get(url).then(function (response) {
        let respuesta = response.data;
        arrayAdmisionPuntaje.value = respuesta.datalist;
        arrayAdmisionPuntajeCol.value = respuesta.columnas;
        //console.log(arrayAdmisionPuntaje.value);
    }).catch(function (error) {
        console.log(error);
    });
}

// Sección Subir archivos de forma general
const arrayFileResources = ref([]);
const arrayFileResourcesCol = ref([]);
const listarFileResources = () => {
    //let url = '/calification/aula'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+props.refCicloActual;
    // let url = '/diarion/fromaulas'+'?id_classroom='+props.classroom.id+'&id_course='+props.course.id+'&ref_ciclo='+ref_ciclo;
    let url = '/document/file_resourceforcourse';
    axios.get(url).then((response) => {
        let respuesta = response.data;
        arrayFileResources.value = respuesta.datalist;
        arrayFileResourcesCol.value = respuesta.columnas;
        //console.log(arrayFileResources.value);
    }).catch((error) => {
        console.log(error);
    });
}

/* const buscarInWeb = () => {
 
    var search = prompt("Termino de busqueda:");
    if (search == null || search == "") {
        alert("User cancelled");
    } else {
        find(search)
    }

} */

const textSearch = ref('')
var TRange = null;

const buscarInWeb = (str) => {
    if (parseInt(navigatorVersion.value) < 4) return;
    var strFound;
    if (window.find) {

        // CODE FOR BROWSERS THAT SUPPORT window.find

        strFound = self.find(str);
        if (!strFound) {
            strFound = self.find(str, 0, 1);
            while (self.find(str, 0, 1)) continue;
        }
    }
    else if (navigatorName.value.indexOf("Microsoft") != -1) {

        // EXPLORER-SPECIFIC CODE

        if (TRange != null) {
            TRange.collapse(false);
            strFound = TRange.findText(str);
            if (strFound) TRange.select();
        }
        if (TRange == null || strFound == 0) {
            TRange = self.document.body.createTextRange();
            strFound = TRange.findText(str);
            if (strFound) TRange.select();
        }
    }
    else if (navigatorName.value == "Opera") {
        alert("Opera browsers not supported, sorry...")
        return;
    }
    if (!strFound) alert("String '" + str + "' not found!")
    return;
}

// Subir archivo
const mensajes = ref([]);
const fileSubida = ref('');
const alertaSubida = ref(0);
const fileOrder = ref(null);
const facture_fecha_emision_txt = ref('');
const fileFormatoTxt = ref(props.formatoTxt);
const eventSubirArchivo = (rutaController) => {
    let formData = new FormData();
    //console.log(fileSubida.value);
    formData.append('file', fileSubida.value);
    formData.append('formattxt', fileFormatoTxt.value);
    if (facture_fecha_emision_txt.value) {
        formData.append('facture_fecha_emision_txt', facture_fecha_emision_txt.value);
    }
    axios.post(rutaController,
        formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    ).then(function (response) {
        //alertaSubida.value = 1;
        let respuesta = response.data;
        //let data = respuesta.data.data;
        if (respuesta.success) {
            //alertaSubida.value = 1;
            //mensajes.value = 'Total registros : '+(data.total-1)+'\nRegistrados : '+data.registered+'\nActualizados : '+data.updated;
            //limpiarVal(5000);
            showAlert(respuesta.message, 'success', 4)
            if (!respuesta.consistencia) messageError.value = respuesta.infoObservados
            if (respuesta.consistencia) messageError.value = null
            //this.$refs.fileOrder.value = null;// <-- Limpiar input file
            //fileOrder.value = null
            console.log(respuesta.debug)

        } else {
            showAlert(respuesta.message, 'danger', 16)
            //alertaSubida.value = 2;
            //mensajes.value = respuesta.data.message;
            //limpiarVal(3000);
        }
    }).catch(function () {
        //alertaSubida.value = 2;
        //limpiarVal(3000);
        showAlert('Registro actualizado', 'danger', 8)
    });
}

const handleFileUploadArchivo = (event) => {
    //fileSubida.value = this.$refs.fileSubida.files[0];
    fileSubida.value = event.target.files[0];
    //console.log(event.target.files[0]);
}

const isAlertActive = ref(false)
const isAlertDangerActive = ref(false)
const messageAlert = ref('')
const messageLastAction = ref('')
const messageError = ref('')
/* const error = ref(0)
const errors = ref([]) */
const colorAlert = ref('success')
const errormsg = ref(null)
const errors = ref(0)
const alertIndex = ref(0)

const showAlert = (message = '', type, time = 1) => {

    messageAlert.value = message
    colorAlert.value = type// <-- Tipo define el color
    isAlertActive.value = true

    // grabar última acción
    messageLastAction.value = message

    /* if (color == 'danger') {
        isAlertDangerActive.value = true
    } else {
        isAlertActive.value = true
    } */
    setTimeout(() => {
        isAlertActive.value = false
        //messageAlert.value = '' <-- Comentar para que no halla error de prop indefined en el componente NotificationAlert
        /* if (color == 'danger') {
            isAlertDangerActive.value = false
        } else {
            isAlertActive.value = false
        } */
        errormsg.value = ref(null)
        errors.value = ref(0)
        alertIndex.value = ref(0)
        //isActionMassive.value = false
    }, time * 1000)// LRR bind(this)


}

/**
 * Section configuration
 * 
 */
console.log(props.confConst)
const tarifaForm = reactive({
    //matriculaGeneral: props.confConst ? props.confConst.matriculaGeneral : 0,
    matriculaInicial: props.confConst ? props.confConst.matriculaInicial : 0,
    matriculaPrimaria: props.confConst ? props.confConst.matriculaPrimaria : 0,
    matriculaSecundaria: props.confConst ? props.confConst.matriculaSecundaria : 0,
    pensionInicial: props.confConst ? props.confConst.pensionInicial : 0,
    pensionPrimaria: props.confConst ? props.confConst.pensionPrimaria : 0,
    pensionSecundaria: props.confConst ? props.confConst.pensionSecundaria : 0,
});

const tarifaSubmit = () => {
    // - LRR mainStore.setUser(profileForm);
    //setUser(profileForm);
    let ruta = 'constante-actualizar-configurations'
    Inertia.put(route(ruta, {
        //'id' : rowID.value,
        'typeConfiguration': 'tarifa',
        //'matriculaGeneral' : tarifaForm.matriculaGeneral,
        'matriculaInicial': tarifaForm.matriculaInicial,
        'matriculaPrimaria': tarifaForm.matriculaPrimaria,
        'matriculaSecundaria': tarifaForm.matriculaSecundaria,
        'pensionInicial': tarifaForm.pensionInicial,
        'pensionPrimaria': tarifaForm.pensionPrimaria,
        'pensionSecundaria': tarifaForm.pensionSecundaria,
    }
    ))
};

const otherConfForm = reactive({
    automatizarAcceso: props.confConst ? props.confConst.automatizarAcceso : 0,
    diaValidarAccesoPago: props.confConst ? props.confConst.diaValidarAccesoPago : 1,
    fechaBloqueo: props.confConst ? props.confConst.fechaBloqueo : '',
    crearOrdenPagoEstudiante: props.confConst ? props.confConst.crearOrdenPagoEstudiante : 0,
    colaboradorPenalidadDescuentoMinuto: props.confConst ? props.confConst.colaboradorPenalidadDescuentoMinuto : '',
    pensionmoraxdia: props.confConst ? props.confConst.pensionmoraxdia : '',
    cobranzamensaje: props.confConst ? props.confConst.cobranzamensaje : '',
});

const otherConfSubmit = () => {
    //
    let ruta = 'constante-actualizar-configurations'
    Inertia.put(route(ruta, {
        //'id' : rowID.value,
        'typeConfiguration': 'finanOtherConf',
        'automatizarAcceso': otherConfForm.automatizarAcceso,
        'diaValidarAccesoPago': otherConfForm.diaValidarAccesoPago,
        'fechaBloqueo': otherConfForm.fechaBloqueo,
        'crearOrdenPagoEstudiante': otherConfForm.crearOrdenPagoEstudiante,
        'colaboradorPenalidadDescuentoMinuto': otherConfForm.colaboradorPenalidadDescuentoMinuto,
        'pensionmoraxdia': otherConfForm.pensionmoraxdia,
        'cobranzamensaje': otherConfForm.cobranzamensaje,
    }
    ))
};

// Desactivar acceso a todos los deudores
const disabledAccesDeudores = () => {
    let arrayitems = props.listStudentsPtePagosRet
    let form = {
        'action': 'disabledAccessDeudores',
        'cr': arrayitems// <-- Minimizar URI checkedRows
    };
    //console.log(arrayitems)
    let url = '/payementOrder/massaction';
    axios.put(url, form).then((response) => {
        let respuesta = response.data;
        console.log(respuesta)
        if (respuesta.success) {
            showAlert(respuesta.message, 'success', 4)
            Inertia.reload({ only: ['listStudentsPtePagosRet', 'studentsDisabledAcces'] })
        } else {
            showAlert(respuesta.message, 'danger', 16)
        }
        console.log('Desactivados Full');

    }).catch((error) => {
        console.log(error);

    });
}

const reloadProps = (contentArray = []) => {
    Inertia.reload({ only: contentArray })
}

const formatDate = (date, type = '') => {
    //var now = new Date().toLocaleDateString()
    var date = new Date(date)// <-- Con let no funcionaba
    //let result = "" + date.getFullYear() + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + (date.getDate() > 9 ? '' : '0') + date.getDate();
    let result = (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
    if (type == 'ISO') {
        result = date.getFullYear() + '-' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '-' + (date.getDate() > 9 ? '' : '0') + date.getDate()
    }
    return result
}

// Ejecutar
const ejecutarConfirm = ref([])
const crearStory = (type = 1) => {

    let ruta = 'student-store-story'
    Inertia.put(route(ruta, {
        //'id' : rowID.value,
        'anio': props.anioEscolar,
        'type': type

    }
    ))

}

const ejecutar = (type = '', name_constant = '', value_constant = '') => {

    let ruta = 'student-ejecutar'
    Inertia.put(route(ruta, {
        //'id' : rowID.value,
        'type': type,
        'name_constant': name_constant,
        'value_constant': value_constant
    }
    ))

}

const showAyuda = ref([
    { 'ordenpago': false },
    { 'configuracion': false },
    { 'cobranzas': false },
    { 'facture': false },
    { 'contabilidad': false }
])

</script>

<template>
    <Head title="Financiera" />

    <NotificationAlert v-model="isAlertActive" :message="messageAlert" :color="colorAlert" />

    <BreezeAuthenticatedLayout>
        <template #header>
            <PremiumPageHeader
                title="Gestión Financiera"
                subtitle="Control de estados de cuenta, facturación, reportes y cobranzas en general."
                icon="tabler:businessplan"
                color="green"
            >
                <template #bottom>
                    <PremiumTabs 
                        v-model="tab" 
                        :tabs="tabsMenu" 
                        @change="handleTabChange" 
                    />
                </template>
            </PremiumPageHeader>
        </template>

        <!-- <CardBoxModal v-model="showDialog" :title="(selectedEvent.title ? selectedEvent.title : 'Información del evento')"
            hasCancel>
            <strong>{{ selectedEvent.start && selectedEvent.start.format('DD/MM/YYYY') }} :
                {{ selectedEvent.start && selectedEvent.start.formatTime() }} -
                {{ selectedEvent.end && selectedEvent.end.formatTime() }}
            </strong>
            <p v-html="selectedEvent.contentFull" />
        </CardBoxModal> -->

        <div class="">
            <template v-if="tab == 0">
                <!-- Resumen (panel principal, paneles pequeños, gráficos e indicadores) -->
                <div class="pb-6">
                    <!-- Filtro Global de Año Escolar -->
                    <div v-if="isAdmin" class="mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center bg-white dark:bg-slate-900 shadow-sm border border-slate-100 dark:border-slate-800 rounded-3xl p-6 gap-4">
                        <div>
                            <h4 class="text-slate-800 dark:text-white text-xl font-bold">Consola de Estadísticas Financieras</h4>
                            <p class="text-slate-400 dark:text-slate-500 text-sm">Monitoreo de ingresos, facturación y cuentas morosas.</p>
                        </div>
                        <div class="flex items-center gap-3">
                            <label class="text-sm text-slate-500 dark:text-slate-400 font-semibold">Año Escolar:</label>
                            <select class="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 text-sm py-2 px-6 focus:ring-emerald-500 focus:border-emerald-500 font-medium" v-model="selectedYearDebtors" @change="changeYearAll">
                                <option :value="parseInt(anioActual) - 3">{{ parseInt(anioActual) - 3 }}</option>
                                <option :value="parseInt(anioActual) - 2">{{ parseInt(anioActual) - 2 }}</option>
                                <option :value="parseInt(anioActual) - 1">{{ parseInt(anioActual) - 1 }}</option>
                                <option :value="anioActual">{{ anioActual }}</option>
                            </select>
                        </div>
                    </div>

                    <div v-if="isAdmin" class="grid grid-cols-1 lg:grid-cols-7 gap-6">
                        <!-- Panel estado de cuenta por periodo -->
                        <div class="col-span-7 lg:col-span-4 bg-white dark:bg-slate-900 shadow-sm border border-slate-100 dark:border-slate-800 rounded-3xl p-6 bg-no-repeat bg-[url('/img/room/bg.png')] bg-contain bg-top h-full transition-all duration-300 hover:shadow-md">
                            <div class="lg:pt-4 h-full">
                                <div>
                                    <h5 class="text-slate-800 dark:text-white text-lg font-bold pb-6">Estado de cuenta por periodo</h5>
                                </div>
                                <div class="bg-white/50 dark:bg-slate-900/50 rounded-2xl p-2 backdrop-blur-sm">
                                    <div v-if="chartOrdenes" class="lg:h-[420px] h-[300px]">
                                        <line-chart :data="chartOrdenes" class="h-full" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-span-7 lg:col-span-3">
                            <div class="grid grid-cols-1 gap-6">
                                <!-- Panel de resumen de ordenes de pago por estado -->
                                <div class="p-6 bg-white dark:bg-slate-900 shadow-sm border border-slate-100 dark:border-slate-800 rounded-3xl transition-all duration-300 hover:shadow-md flex flex-col justify-center">
                                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 divide-y sm:divide-y-0 sm:divide-x divide-slate-100 dark:divide-slate-800">
                                        <!-- Stat 1 -->
                                        <div class="flex flex-col items-center justify-center pt-4 sm:pt-0">
                                            <h6 class="mb-3 w-full text-sm font-semibold text-slate-500 dark:text-slate-400 text-center">Pte. Pago - En retraso</h6>
                                            <div class="flex items-center justify-center space-x-3 bg-slate-50 dark:bg-slate-800/50 px-4 py-2 rounded-2xl">
                                                <div class="flex items-center gap-1.5" title="Pensiones o matrícula que están pendientes de pago">
                                                    <BaseIcon :path="mdiArrowUpCircle" :size="20" class="text-emerald-500" />
                                                    <span class="text-lg font-bold text-slate-700 dark:text-slate-200">{{ orderPtePagos }}</span>
                                                </div>
                                                <span class="text-slate-300 dark:text-slate-600 font-light text-xl">|</span>
                                                <div class="flex items-center gap-1.5" title="Pensiones o matrícula que pasó la fecha de vencimiento">
                                                    <span class="text-lg font-bold text-slate-700 dark:text-slate-200">{{ orderPtePagosRet }}</span>
                                                    <BaseIcon :path="mdiArrowDownCircle" :size="20" class="text-rose-500" />
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <!-- Stat 2 -->
                                        <div class="flex flex-col items-center justify-center pt-4 sm:pt-0">
                                            <div class="mb-3 w-full text-center">
                                                <BreezeDropdown>
                                                    <template #trigger>
                                                        <button type="button" class="inline-flex items-center gap-1 text-sm font-semibold text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-300 transition-colors">
                                                            Deudores - Sin acceso
                                                            <Icon icon="tabler:chevron-down" class="w-4 h-4" />
                                                        </button>
                                                    </template>
                                                    <template v-if="isAdmin" #content>
                                                        <BreezeDropdownLink @click="disabledAccesDeudores()">
                                                            <span title="Todos lo que no tengan compromiso de pago o que tengan compromiso de pago vencidas">Desactivar acceso a los deudores</span>
                                                        </BreezeDropdownLink>
                                                    </template>
                                                </BreezeDropdown>
                                            </div>
                                            <div class="flex items-center justify-center space-x-3 bg-slate-50 dark:bg-slate-800/50 px-4 py-2 rounded-2xl">
                                                <div class="flex items-center gap-1.5" title="Alumnos no retirados que tienen pagos en retraso">
                                                    <BaseIcon :path="mdiArrowUpCircle" :size="20" class="text-emerald-500" />
                                                    <span class="text-lg font-bold text-slate-700 dark:text-slate-200">{{ studentsPtePagosRet }}</span>
                                                </div>
                                                <span class="text-slate-300 dark:text-slate-600 font-light text-xl">|</span>
                                                <div class="flex items-center gap-1.5" title="Alumnos no retirados sin acceso al sistema">
                                                    <span class="text-lg font-bold text-slate-700 dark:text-slate-200">{{ studentsDisabledAcces }}</span>
                                                    <BaseIcon :path="mdiArrowDownCircle" :size="20" class="text-rose-500" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <hr v-if="confGlobal.value.FINANCIERA_USE_FACTURACION == 1" class="my-6 border-slate-100 dark:border-slate-800">
                                    
                                    <div v-if="confGlobal.value.FINANCIERA_USE_FACTURACION == 1" class="grid grid-cols-1 sm:grid-cols-2 gap-6 divide-y sm:divide-y-0 sm:divide-x divide-slate-100 dark:divide-slate-800">
                                        <!-- Stat 3 -->
                                        <div class="flex flex-col items-center justify-center pt-4 sm:pt-0">
                                            <h6 class="mb-3 w-full text-sm font-semibold text-slate-500 dark:text-slate-400 text-center" title="Órdenes pagadas facturadas y por facturar">Facturado - No Facturado</h6>
                                            <div class="flex items-center justify-center space-x-3 bg-slate-50 dark:bg-slate-800/50 px-4 py-2 rounded-2xl">
                                                <span class="text-lg font-bold text-emerald-500">{{ orderFacturado }}</span>
                                                <span class="text-slate-300 dark:text-slate-600 font-light text-xl">|</span>
                                                <span class="text-lg font-bold text-rose-500">{{ orderNoFacturado }}</span>
                                            </div>
                                        </div>

                                        <!-- Stat 4 -->
                                        <div class="flex flex-col items-center justify-center pt-4 sm:pt-0">
                                            <h6 class="mb-3 w-full text-sm font-semibold text-slate-500 dark:text-slate-400 text-center" title="Estado de respuesta de Sunat">Aceptado - Enviado - Observado</h6>
                                            <div class="flex items-center justify-center space-x-3 bg-slate-50 dark:bg-slate-800/50 px-4 py-2 rounded-2xl">
                                                <span class="text-lg font-bold text-emerald-500">{{ factureAceptado }}</span>
                                                <span class="text-slate-300 dark:text-slate-600 font-light text-xl">|</span>
                                                <span class="text-lg font-bold text-emerald-500">{{ factureEnviado }}</span>
                                                <span class="text-slate-300 dark:text-slate-600 font-light text-xl">|</span>
                                                <span class="text-lg font-bold text-rose-500">{{ factureObservado }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Panel pendientes de pago vencidas por mes -->
                                 <div class="p-6 bg-white dark:bg-slate-900 shadow-sm border border-slate-100 dark:border-slate-800 rounded-3xl transition-all duration-300 hover:shadow-md">
                                     <div>
                                         <h5 class="text-slate-800 dark:text-white text-lg font-bold pb-4">Pendientes de pago vencidas</h5>
                                     </div>
                                     <div class="mt-2 h-64 sm:h-[280px]">
                                         <div v-if="chartPendientes" class="h-full w-full">
                                             <bar-chart :data="chartPendientes" class="h-full" />
                                         </div>
                                     </div>
                                 </div>
                             </div>
                         </div>
                     </div>
                     <!-- Métricas Financieras Clave (KPIs) -->
                     <div v-if="isAdmin && financialSummaryData" class="mt-6 grid grid-cols-1 md:grid-cols-3 gap-6">
                         <!-- Card Total Emitido en órdenes de pago (las facturas no son necesariamente órdenes de pago) -->
                         <div class="bg-white dark:bg-slate-900 shadow-sm border border-slate-100 dark:border-slate-800 rounded-3xl p-6 transition-all duration-300 hover:shadow-md flex items-center justify-between">
                             <div>
                                 <p class="text-slate-400 dark:text-slate-500 text-sm font-semibold uppercase tracking-wider">Total Ordenes</p>
                                 <h3 class="text-2xl lg:text-3xl font-black text-slate-800 dark:text-white mt-2">
                                     S/ {{ financialSummaryData.total_orders ? financialSummaryData.total_orders.toLocaleString('es-PE', { minimumFractionDigits: 2 }) : '0.00' }}
                                 </h3>
                                 <p class="text-slate-400 dark:text-slate-500 text-xs mt-1">Total emitido en órdenes de pago en el año</p>
                             </div>
                             <div class="p-4 bg-sky-50 dark:bg-sky-950/30 text-sky-600 dark:text-sky-400 rounded-2xl">
                                 <Icon icon="tabler:file-invoice" class="w-8 h-8" />
                             </div>
                         </div>

                         <!-- Card Total Recaudado / Cobrado -->
                         <div class="bg-white dark:bg-slate-900 shadow-sm border border-slate-100 dark:border-slate-800 rounded-3xl p-6 transition-all duration-300 hover:shadow-md flex items-center justify-between">
                             <div>
                                 <p class="text-slate-400 dark:text-slate-500 text-sm font-semibold uppercase tracking-wider">Total Recaudado</p>
                                 <h3 class="text-2xl lg:text-3xl font-black text-emerald-600 dark:text-emerald-400 mt-2">
                                     S/ {{ financialSummaryData.total_collected ? financialSummaryData.total_collected.toLocaleString('es-PE', { minimumFractionDigits: 2 }) : '0.00' }}
                                 </h3>
                                 <div class="flex items-center gap-2 mt-1">
                                     <span class="inline-flex px-2 py-0.5 bg-emerald-50 dark:bg-emerald-950/30 text-emerald-600 dark:text-emerald-400 text-xs font-bold rounded-lg">
                                         {{ financialSummaryData.collection_rate }}% Cobrado
                                     </span>
                                 </div>
                             </div>
                             <div class="p-4 bg-emerald-50 dark:bg-emerald-950/30 text-emerald-600 dark:text-emerald-400 rounded-2xl">
                                 <Icon icon="tabler:cash" class="w-8 h-8" />
                             </div>
                         </div>

                         <!-- Card Total Pendiente / Mora -->
                         <div class="bg-white dark:bg-slate-900 shadow-sm border border-slate-100 dark:border-slate-800 rounded-3xl p-6 transition-all duration-300 hover:shadow-md flex items-center justify-between">
                             <div>
                                 <p class="text-slate-400 dark:text-slate-500 text-sm font-semibold uppercase tracking-wider">Total Pendiente (Mora)</p>
                                 <h3 class="text-2xl lg:text-3xl font-black text-rose-600 dark:text-rose-400 mt-2">
                                     S/ {{ financialSummaryData.total_pending ? financialSummaryData.total_pending.toLocaleString('es-PE', { minimumFractionDigits: 2 }) : '0.00' }}
                                 </h3>
                                 <div class="flex items-center gap-2 mt-1">
                                     <span class="inline-flex px-2 py-0.5 bg-rose-50 dark:bg-rose-950/30 text-rose-600 dark:text-rose-400 text-xs font-bold rounded-lg">
                                         {{ financialSummaryData.morosity_rate }}% Morosidad
                                     </span>
                                 </div>
                             </div>
                             <div class="p-4 bg-rose-50 dark:bg-rose-950/30 text-rose-600 dark:text-rose-400 rounded-2xl">
                                 <Icon icon="tabler:alert-triangle" class="w-8 h-8" />
                             </div>
                         </div>
                     </div>

                    <!-- Grilla de Paneles de Deudores -->
                    <div class="mt-6 grid grid-cols-1 lg:grid-cols-7 gap-6">
                        <!-- Panel de deudores por nivel educativo -->
                        <div class="bg-white dark:bg-slate-900 shadow-sm border border-slate-100 dark:border-slate-800 rounded-3xl p-6 transition-all duration-300 hover:shadow-md col-span-4">
                            <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                                <div>
                                    <h5 class="text-slate-800 dark:text-white text-lg font-bold">Deudores por Nivel Educativo</h5>
                                    <p class="text-slate-400 dark:text-slate-500 text-sm">Resumen agrupado por el nivel del alumno con pagos vencidos.</p>
                                </div>
                                <div v-if="isAdmin" class="flex items-center gap-3">
                                    <a :href="route('payementOrder-exportDebtorsByLevel', { anioSearch: selectedYearDebtors || '' })" class="inline-flex items-center gap-2 px-3 py-1.5 bg-emerald-50 hover:bg-emerald-100 dark:bg-emerald-950/30 dark:hover:bg-emerald-950/50 text-emerald-600 dark:text-emerald-400 font-semibold text-xs rounded-xl transition-all border border-emerald-100 dark:border-emerald-900/30 cursor-pointer">
                                        <Icon icon="tabler:file-excel" class="w-4 h-4" />
                                        Exportar
                                    </a>
                                </div>
                            </div>
                            <div class="overflow-x-auto rounded-2xl border border-slate-100 dark:border-slate-800">
                                <table class="w-full text-left border-collapse">
                                    <thead>
                                        <tr class="bg-slate-50/75 dark:bg-slate-800/25">
                                            <th class="py-3 px-4 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider w-28">Código</th>
                                            <th class="py-3 px-4 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Nivel Educativo</th>
                                            <th class="py-3 px-4 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider text-center w-28">Deudores</th>
                                            <th v-if="isAdmin" class="py-3 px-4 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider text-right w-36">Monto Pendiente</th>
                                        </tr>
                                    </thead>
                                    <tbody class="divide-y divide-slate-100 dark:divide-slate-800 bg-white dark:bg-slate-900">
                                        <tr v-if="levelDebtorsData && levelDebtorsData.length" v-for="level in levelDebtorsData" :key="level.level_ref" class="hover:bg-slate-50/50 dark:hover:bg-slate-800/10 transition-colors">
                                            <td class="py-3.5 px-4 text-sm font-semibold text-slate-600 dark:text-slate-300">
                                                <span class="inline-flex px-2 py-1 bg-slate-100 dark:bg-slate-800 rounded-lg text-xs font-mono">{{ level.level_ref }}</span>
                                            </td>
                                            <td class="py-3.5 px-4 text-sm font-medium text-slate-700 dark:text-slate-200">{{ level.level_label }}</td>
                                            <td class="py-3.5 px-4 text-sm text-center">
                                                <span class="inline-flex px-2.5 py-1 bg-rose-50 dark:bg-rose-950/20 text-rose-600 dark:text-rose-400 rounded-full text-xs font-semibold">{{ level.cant_deudores }}</span>
                                            </td>
                                            <td v-if="isAdmin" class="py-3.5 px-4 text-sm text-right font-semibold text-slate-800 dark:text-slate-100">
                                                S/ {{ parseFloat(level.monto_pendiente).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                            </td>
                                        </tr>
                                        <tr v-else>
                                            <td class="py-8 px-4 text-sm text-slate-500 dark:text-slate-400 text-center" colspan="4">No hay deudores registrados...</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="bg-slate-50/50 dark:bg-slate-800/20 font-bold border-t border-slate-200 dark:border-slate-700">
                                            <td class="py-3.5 px-4 text-sm text-slate-800 dark:text-slate-200" colspan="2">TOTAL</td>
                                            <td class="py-3.5 px-4 text-sm text-center text-rose-600 dark:text-rose-400">
                                                {{ totalDebtors }}
                                            </td>
                                            <td v-if="isAdmin" class="py-3.5 px-4 text-sm text-right text-slate-900 dark:text-white">
                                                S/ {{ totalPendingAmount.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>

                        <!-- Panel de deudores por concepto -->
                        <div class="bg-white dark:bg-slate-900 shadow-sm border border-slate-100 dark:border-slate-800 rounded-3xl p-6 transition-all duration-300 hover:shadow-md col-span-3">
                            <div class="mb-6">
                                <h5 class="text-slate-800 dark:text-white text-lg font-bold">Deuda por Concepto</h5>
                                <p class="text-slate-400 dark:text-slate-500 text-sm">Distribución de morosidad por concepto de cobro.</p>
                            </div>
                            <div class="overflow-x-auto rounded-2xl border border-slate-100 dark:border-slate-800">
                                <table class="w-full text-left border-collapse">
                                    <thead>
                                        <tr class="bg-slate-50/75 dark:bg-slate-800/25">
                                            <th class="py-3 px-4 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Concepto</th>
                                            <th class="py-3 px-4 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider text-center w-24">Órdenes (estudiantes)</th>
                                            <th v-if="isAdmin" class="py-3 px-4 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider text-right w-32">Monto</th>
                                        </tr>
                                    </thead>
                                    <tbody class="divide-y divide-slate-100 dark:divide-slate-800 bg-white dark:bg-slate-900">
                                        <tr v-if="conceptDebtData && conceptDebtData.length" v-for="concept in conceptDebtData" :key="concept.concept_label" class="hover:bg-slate-50/50 dark:hover:bg-slate-800/10 transition-colors">
                                            <td class="py-3.5 px-4 text-sm font-medium text-slate-700 dark:text-slate-200">
                                                {{ concept.concept_label }}
                                            </td>
                                            <td class="py-3.5 px-4 text-sm text-center">
                                                <span class="inline-flex px-2 py-0.5 bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400 rounded-full text-xs font-semibold">
                                                    {{ concept.cant_deudores }}
                                                </span>
                                            </td>
                                            <td v-if="isAdmin" class="py-3.5 px-4 text-sm text-right font-semibold text-slate-800 dark:text-slate-100">
                                                S/ {{ parseFloat(concept.monto_pendiente).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                            </td>
                                        </tr>
                                        <tr v-else>
                                            <td class="py-8 px-4 text-sm text-slate-500 dark:text-slate-400 text-center" colspan="3">No hay deuda por concepto...</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr class="bg-slate-50/50 dark:bg-slate-800/20 font-bold border-t border-slate-200 dark:border-slate-700">
                                            <td class="py-3.5 px-4 text-sm text-slate-800 dark:text-slate-200">TOTAL</td>
                                            <td class="py-3.5 px-4 text-sm text-center text-slate-500 dark:text-slate-400">
                                                {{ conceptDebtData ? conceptDebtData.reduce((sum, item) => sum + parseInt(item.cant_deudores || 0), 0) : 0 }}
                                            </td>
                                            <td v-if="isAdmin" class="py-3.5 px-4 text-sm text-right text-slate-900 dark:text-white">
                                                S/ {{ conceptDebtData ? conceptDebtData.reduce((sum, item) => sum + parseFloat(item.monto_pendiente || 0), 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00' }}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                    </div>
                     <!-- Panel Deudores por Concepto agrupados por Nivel -->
                    <div class="mt-6 bg-white dark:bg-slate-900 shadow-sm border border-slate-100 dark:border-slate-800 rounded-3xl p-6 transition-all duration-300 hover:shadow-md">
                        <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                            <div>
                                <h5 class="text-slate-800 dark:text-white text-lg font-bold">Deudores por Concepto y por Nivel</h5>
                                <p class="text-slate-400 dark:text-slate-500 text-sm">Resumen detallado cruzando el concepto de cobro pendiente y el nivel del alumno.</p>
                            </div>
                            <div v-if="isAdmin">
                                <a :href="route('payementOrder-exportDebtorsByLevelAndConcept', { anioSearch: selectedYearDebtors || '' })" class="inline-flex items-center gap-2 px-3 py-1.5 bg-emerald-50 hover:bg-emerald-100 dark:bg-emerald-950/30 dark:hover:bg-emerald-950/50 text-emerald-600 dark:text-emerald-400 font-semibold text-xs rounded-xl transition-all border border-emerald-100 dark:border-emerald-900/30 cursor-pointer">
                                    <Icon icon="tabler:file-excel" class="w-4 h-4" />
                                    Exportar Excel Detallado
                                </a>
                            </div>
                        </div>
                        <div class="overflow-x-auto rounded-2xl border border-slate-100 dark:border-slate-800">
                            <table class="w-full text-left border-collapse">
                                <thead>
                                    <tr class="bg-slate-50/75 dark:bg-slate-800/25">
                                        <th class="py-3 px-4 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider w-28">Código Nivel</th>
                                        <th class="py-3 px-4 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Nivel Educativo</th>
                                        <th v-for="concept in pivotedDebtorsData.concepts" :key="concept" class="py-3 px-4 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider text-center">
                                            {{ concept }}
                                        </th>
                                        <th class="py-3 px-4 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider text-center w-28">Deudores (Únicos)</th>
                                        <th class="py-3 px-4 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider text-center w-28">Deudas Totales (órdenes)</th>
                                        <th v-if="isAdmin" class="py-3 px-4 text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider text-right w-36">Monto Pendiente</th>
                                    </tr>
                                </thead>
                                <tbody class="divide-y divide-slate-100 dark:divide-slate-800 bg-white dark:bg-slate-900">
                                    <tr v-if="pivotedDebtorsData.rows && pivotedDebtorsData.rows.length" v-for="row in pivotedDebtorsData.rows" :key="row.level_ref" class="hover:bg-slate-50/50 dark:hover:bg-slate-800/10 transition-colors">
                                        <td class="py-3.5 px-4 text-sm font-semibold text-slate-600 dark:text-slate-300">
                                            <span class="inline-flex px-2 py-1 bg-slate-100 dark:bg-slate-800 rounded-lg text-xs font-mono">{{ row.level_ref }}</span>
                                        </td>
                                        <td class="py-3.5 px-4 text-sm font-medium text-slate-700 dark:text-slate-200">{{ row.level_label }}</td>
                                        <td v-for="concept in pivotedDebtorsData.concepts" :key="concept" class="py-3.5 px-4 text-center">
                                            <div v-if="row.concepts[concept]" class="flex flex-col items-center">
                                                <span class="inline-flex px-2 py-0.5 bg-rose-50 dark:bg-rose-950/20 text-rose-600 dark:text-rose-400 rounded-full text-xs font-semibold">
                                                    {{ row.concepts[concept].cant_deudores }}
                                                </span>
                                                <span v-if="isAdmin" class="text-[11px] text-slate-500 dark:text-slate-400 mt-0.5 font-medium">
                                                    S/ {{ row.concepts[concept].monto_pendiente.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                                </span>
                                            </div>
                                            <span v-else class="text-slate-300 dark:text-slate-700">-</span>
                                        </td>
                                        <td class="py-3.5 px-4 text-sm text-center">
                                            <span class="inline-flex px-2.5 py-1 bg-rose-100 dark:bg-rose-950/40 text-rose-700 dark:text-rose-300 rounded-full text-xs font-bold">
                                                {{ row.total_deudores }}
                                            </span>
                                        </td>
                                        <td class="py-3.5 px-4 text-sm text-center">
                                            <span class="inline-flex px-2.5 py-1 bg-slate-100 dark:bg-slate-800 text-slate-700 dark:text-slate-300 rounded-full text-xs font-bold">
                                                {{ row.total_deudas_totales }}
                                            </span>
                                        </td>
                                        <td v-if="isAdmin" class="py-3.5 px-4 text-sm text-right font-bold text-slate-900 dark:text-white">
                                            S/ {{ row.total_monto.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                        </td>
                                    </tr>
                                    <tr v-else>
                                        <td class="py-8 px-4 text-sm text-slate-500 dark:text-slate-400 text-center" :colspan="pivotedDebtorsData.concepts.length + 5">No hay deudores registrados...</td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr class="bg-slate-50/50 dark:bg-slate-800/20 font-bold border-t border-slate-200 dark:border-slate-700">
                                        <td class="py-3.5 px-4 text-sm text-slate-800 dark:text-slate-200" colspan="2">TOTAL GENERAL</td>
                                        <td v-for="concept in pivotedDebtorsData.concepts" :key="concept" class="py-3.5 px-4 text-center">
                                            <div v-if="pivotedConceptTotals[concept] && pivotedConceptTotals[concept].cant_deudores > 0" class="flex flex-col items-center">
                                                <span class="text-rose-600 dark:text-rose-400 text-xs font-bold">{{ pivotedConceptTotals[concept].cant_deudores }}</span>
                                                <span v-if="isAdmin" class="text-[11px] text-slate-800 dark:text-slate-200 font-bold">
                                                    S/ {{ pivotedConceptTotals[concept].monto_pendiente.toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                                </span>
                                            </div>
                                            <span v-else class="text-slate-400 dark:text-slate-600">-</span>
                                        </td>
                                        <td class="py-3.5 px-4 text-sm text-center text-rose-700 dark:text-rose-300">
                                            {{ levelDebtorsData ? levelDebtorsData.reduce((sum, item) => sum + parseInt(item.cant_deudores || 0), 0) : 0 }}
                                        </td>
                                        <td class="py-3.5 px-4 text-sm text-center text-slate-700 dark:text-slate-300">
                                            {{ pivotedDebtorsData.rows ? pivotedDebtorsData.rows.reduce((sum, row) => sum + row.total_deudas_totales, 0) : 0 }}
                                        </td>
                                        <td v-if="isAdmin" class="py-3.5 px-4 text-sm text-right text-slate-900 dark:text-white">
                                            S/ {{ levelDebtorsData ? levelDebtorsData.reduce((sum, item) => sum + parseFloat(item.monto_pendiente || 0), 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00' }}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                 </div>

                 <!-- Sección listas -->
                 <div class="pb-6">
                    <div class="grid gap-6 cols-1 xl:grid-cols-2">
                        <div class="grid gap-6 h-max">
                            <!-- Lista Becados -->
                            <div class="bg-white dark:bg-slate-900 shadow-sm border border-slate-100 dark:border-slate-800 rounded-3xl p-6 transition-all duration-300 hover:shadow-md">
                                <h5 class="text-slate-800 dark:text-white text-lg font-bold mb-4">Lista de alumnos Becados</h5>
                                <div class="overflow-x-auto overflow-y-auto max-h-[400px] custom-scrollbar rounded-2xl border border-slate-200 dark:border-slate-700">
                                    <table class="w-full text-left border-collapse">
                                        <thead class="bg-slate-50 dark:bg-slate-800/50 sticky top-0 z-10 backdrop-blur-sm">
                                            <tr>
                                                <th scope="col" class="py-3 px-4 text-xs font-semibold text-slate-500 uppercase tracking-wider border-b border-slate-200 dark:border-slate-700 w-16">#</th>
                                                <th scope="col" class="py-3 px-4 text-xs font-semibold text-slate-500 uppercase tracking-wider border-b border-slate-200 dark:border-slate-700">Alumno</th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-slate-100 dark:divide-slate-800 bg-white dark:bg-slate-900">
                                            <tr v-if="studentBecados.length" v-for="(client, index) in studentBecados" :key="client.id" class="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                                                <td class="py-3 px-4 text-sm text-slate-500 dark:text-slate-400">{{ index + 1 }}</td>
                                                <td class="py-3 px-4 text-sm font-medium text-slate-700 dark:text-slate-200">{{ client.apellidos }} {{ client.nombres }}</td>
                                            </tr>
                                            <tr v-else>
                                                <td class="py-8 px-4 text-sm text-slate-500 dark:text-slate-400 text-center" colspan="2">No existen registros...</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            
                            <!-- Compromiso de Pago -->
                            <div class="bg-white dark:bg-slate-900 shadow-sm border border-slate-100 dark:border-slate-800 rounded-3xl p-6 transition-all duration-300 hover:shadow-md">
                                <h5 class="text-slate-800 dark:text-white text-lg font-bold mb-4">Deudores con compromiso de pago</h5>
                                <div class="overflow-x-auto overflow-y-auto max-h-[400px] custom-scrollbar rounded-2xl border border-slate-200 dark:border-slate-700">
                                    <table class="w-full text-left border-collapse">
                                        <thead class="bg-slate-50 dark:bg-slate-800/50 sticky top-0 z-10 backdrop-blur-sm">
                                            <tr>
                                                <th scope="col" class="py-3 px-4 text-xs font-semibold text-slate-500 uppercase tracking-wider border-b border-slate-200 dark:border-slate-700 w-16">#</th>
                                                <th scope="col" class="py-3 px-4 text-xs font-semibold text-slate-500 uppercase tracking-wider border-b border-slate-200 dark:border-slate-700">Alumno</th>
                                                <th scope="col" class="py-3 px-4 text-xs font-semibold text-slate-500 uppercase tracking-wider border-b border-slate-200 dark:border-slate-700 w-48 text-right">Fecha compromiso</th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-slate-100 dark:divide-slate-800 bg-white dark:bg-slate-900">
                                            <tr v-if="studentCompromisoPago.length" v-for="(client, index) in studentCompromisoPago" :key="client.id" class="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                                                <td class="py-3 px-4 text-sm text-slate-500 dark:text-slate-400">{{ index + 1 }}</td>
                                                <td class="py-3 px-4 text-sm font-medium text-slate-700 dark:text-slate-200">{{ client.apellidos }} {{ client.nombres }}</td>
                                                <td class="py-3 px-4 text-sm text-right font-medium" :class="(client.fecha_compromiso_pago && client.fecha_compromiso_pago < (formatDate(new Date(), 'ISO')) ? 'text-rose-600' : 'text-slate-600 dark:text-slate-300')"> {{ client.fecha_compromiso_pago }} </td>
                                            </tr>
                                            <tr v-else>
                                                <td class="py-8 px-4 text-sm text-slate-500 dark:text-slate-400 text-center" colspan="3">No existen registros...</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Pensión Preferencial -->
                        <div class="h-max">
                            <div class="bg-white dark:bg-slate-900 shadow-sm border border-slate-100 dark:border-slate-800 rounded-3xl p-6 transition-all duration-300 hover:shadow-md">
                                <h5 class="text-slate-800 dark:text-white text-lg font-bold mb-4">Lista de alumnos con Pensión Preferencial</h5>
                                <div class="overflow-x-auto overflow-y-auto max-h-[850px] custom-scrollbar rounded-2xl border border-slate-200 dark:border-slate-700">
                                    <table class="w-full text-left border-collapse">
                                        <thead class="bg-slate-50 dark:bg-slate-800/50 sticky top-0 z-10 backdrop-blur-sm">
                                            <tr>
                                                <th scope="col" class="py-3 px-4 text-xs font-semibold text-slate-500 uppercase tracking-wider border-b border-slate-200 dark:border-slate-700 w-16">#</th>
                                                <th scope="col" class="py-3 px-4 text-xs font-semibold text-slate-500 uppercase tracking-wider border-b border-slate-200 dark:border-slate-700">Alumno</th>
                                                <th v-if="isAdmin" scope="col" class="py-3 px-4 text-xs font-semibold text-slate-500 uppercase tracking-wider border-b border-slate-200 dark:border-slate-700 w-32 text-right">Pensión</th>
                                            </tr>
                                        </thead>
                                        <tbody class="divide-y divide-slate-100 dark:divide-slate-800 bg-white dark:bg-slate-900">
                                            <tr v-if="studentPensionPref.length" v-for="(client, index) in studentPensionPref" :key="client.id" class="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
                                                <td class="py-3 px-4 text-sm text-slate-500 dark:text-slate-400">{{ index + 1 }}</td>
                                                <td class="py-3 px-4 text-sm font-medium text-slate-700 dark:text-slate-200">{{ client.apellidos }} {{ client.nombres }}</td>
                                                <td v-if="isAdmin" class="py-3 px-4 text-sm text-right font-semibold text-indigo-600 dark:text-indigo-400">{{ client.pension_preferencial }}</td>
                                            </tr>
                                            <tr v-else>
                                                <td class="py-8 px-4 text-sm text-slate-500 dark:text-slate-400 text-center" :colspan="isAdmin ? 3 : 2">No existen registros...</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </template>
            <template v-else-if="tab == 1">
                <!-- Estados de cuenta (órdenes de pago) -->
                <div class="shadow-lg border rounded-md p-4 bg-white">
                    <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

                    <div class="mb-2">
                        <a href="#" class="group relative inline-block text-blue-500 underline hover:text-red-500 duration-300" @click="showAyuda['ordenpago'] = !showAyuda['ordenpago']">
                            Ayuda
                            <BaseIcon :path="mdiInformationOutline" size="15" />
                        </a>
                        <div v-if="showAyuda['ordenpago']">
                            <ul>
                                <li>ATENCIÓN: Si hay más de una entidad (empresa), el estudiantes debe tener asignado el nivel, esto determina la entidad.</li>
                                <li>El año de consulta actual es por default, si requiere de años anteriores cambiar el año.</li>
                                <li>Si falta las órdenes sólo inicialice la orden de pago para agregar al que falta en la sección procesar pagos.</li>
                                <li>Los registros Sin alta puede cambiar precios, establecer como Pte. Pago o eliminar (a menos que esté la opción de Pdte. de pago por default)</li>
                                <li>Los registros Pte pago son los que ya están en alta. Y estos se pueden establecer como pagados.</li>
                                <li>Sólo aplica el cambio de la fecha de vencimiento si el registro es Sin alta o pendiente de pago.</li>
                                <li>Matricular (Si matricula ya está pagado): Si el estudiante es antiguo y promovido o retirado, establece la fecha de matrícula por la del pago, cambia el estado de retirado a activo y aumenta un nivel o grado del estudiante a partir del nivel de Inicial 3 años</li>
                                <li>Los txt de alta (P) se genera si filtra sin alta. Selecciona todos o uno por uno, una vez subido al banco ustede debe actualizar estas como Pte. Pago</li>
                                <li>Los txt de baja (E) se genera si filtra Pte. Pago. Selecciona todos o uno por uno, una vez subido al banco debe pasar a Sin alta y luego eliminarlo</li>
                                <li v-if="confGlobal.value.FINANCIERA_USE_FACTURACION == 1">La facturación electrónica está activa.
                                    <ul>
                                        <li>Al facturar la fecha de emisión es la de hoy por default y valor total de IGV por default es 0 (inafecto por default), el cliente será el DNI del apoderado responsable de pagos o del estudiante si es que se estableció así.</li>
                                        <li>La opción facturar pagadas por comprobante crear un comprobante por cada orden de pago. La opción facturar pagadas a un único comprobante; crea un sólo comprobante de varias órdenes de pago, para esto debe seleccionar sólo un estudiante.</li>
                                        <li v-if="confGlobal.value.FINANCIERA_FACTURACION_MODIFY_EMISION_DATE == 1">Puede cambiar la fecha de emisión si lo requiere. <b>¡tenga cuidado en la consistencia de correlativo y fecha!</b></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <!-- <li>Verificar que los totales con su decimales sean correctos</li> -->
                    </div>

                    <CardBox v-if="arrayOrdenPago && arrayOrdenPago.length" class="mb-6" has-table>
                        <!-- Tablesingle opciones: checkable -->
                        <div class="w-full overflow-x-auto relative">
                            <TableAdvanced modulo="payementOrder" modulos="Estados de cuenta" :data="arrayOrdenPago" :fields="arrayOrdenPagoCol" ruta="payementOrder" exporteable searchAdvance :checkable="(isAdmin ? true : false)" :massDelete="(isAdmin ? true : false)" isSearchYear :userParam="userParamOrdenPago" :debugInertia="confGlobal.value.DEBUG_DISABLE_REFRESH_INERTIA == 1" /><!-- showTotales propiedad para PDF-->
                        </div>
                    </CardBox>
                    <CardBox v-else>
                        <CardBoxComponentEmpty />
                    </CardBox>
                </div>
            </template>
            <template v-else-if="tab == 2">
                <!-- Procesar pagos -->
                <div class="shadow-lg border rounded-md p-4 bg-white">
                    <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

                    <div>
                        <p v-if="messageLastAction" class="p-6">
                            <span v-text="'Última acción realizada: ' + messageLastAction" class="text-blue-600"></span>
                        </p>
                        <p v-if="messageError" class="mx-6 my-2">
                            <span v-text="'Inconsistencia: ' + messageError" class="text-red-600"></span>
                        </p>

                        <!-- <span @click="showUpdateOrden=!showUpdateOrden">[ +  Actualizar órdenes de pago]</span> -->
                        <div class="tab-card tab-light mb-4">
                            <input class="tab-input" id="tab-actualizarPago" type="checkbox">
                            <label @click="showUpdateOrden = !showUpdateOrden" class="tab-label ico-checkbox" for="tab-actualizarPago">
                                <div>
                                    <span>
                                        <BaseIcon :path="mdiClipboardEdit" :size="24" class="mr-3 " />
                                        Actualizar órdenes de pago
                                    </span>
                                </div>
                            </label>
                            <div v-if="showUpdateOrden" class="tab-content p-3">
                                <!-- <div
                                            class="card-head bg-rose-600 border-rose-600 text-white rounded-t-2xl flex flex-col p-6 transition-colors">
                                            Formato BBVA
                                            <p class="card-subtitle">Máximo 50 registros por archivo, los campos son <b>sensibles</b> a espacios, <b>minúsculas y mayúsculas</b>.</p>
                                        </div> -->
                                <ul>
                                    <li v-if="confGlobal.value.FINANCIERA_FORMATO_PAGO_TXT > 0">TXT de pagos
                                        <ul>
                                            <li>Puede cambiar El formato TXT si lo requiere
                                                <select class="rounded-lg" v-model="fileFormatoTxt">
                                                    <option value="1">Formato TXT BBVA</option>
                                                    <option value="2">Formato TXT Scotiabank</option>
                                                </select>
                                                <small>¡Puede configurar el formato por default si es necesario!</small>

                                            </li>
                                        </ul>
                                    </li>
                                    <li>Verificar que la consistencia de pagos sea correcta; cantidad de registros y totales</li>
                                    <li v-if="confGlobal.value.ACTUALIZAR_ACCESO_ALUMNO_FILE_BANCO == 1"> Desactivar accesos si el periodo de pago es menor al periodo anterior del periodo actual:
                                        Si tiene fecha de compromiso de pago vencida. Si el día de hoy es mayor a {{ confGlobal.value.DIA_LIMITE_ACCESO_ALUMNO_FILE_BANCO }}.
                                        Si el pago es del periodo inferior al anterior entonces debe el último periodo por ello el acceso será desactivado hasta que pague el último.
                                    </li>
                                    <li v-if="confGlobal.value.ACTUALIZAR_ACCESO_ALUMNO_FILE_BANCO == 1">Activar accesos:
                                        Si el periodo de pago es mayor o igual al periodo anterior del periodo actual.
                                        Si el día actual es menor o igual a {{ confGlobal.value.DIA_LIMITE_ACCESO_ALUMNO_FILE_BANCO }} y el periodo de pago es mayor o igual al periodo anterior del anterior del periodo actual.
                                    </li>
                                    <li v-if="confGlobal.value.MATRICULA_CLASSROOM_UP == 1">Matricular:
                                        Si el pago es por matrícula se actualizará el nivel, aula de estudio y matrícula por la siguiente más cercana si es que existe. El aula ugel se actualizará por la primera coincidencia de uno u otro código modular.
                                        Deben verificar luego de las matrículas si la posición de las 3 aulas son las correctas.
                                    </li>
                                    <li v-if="confGlobal.value.FINANCIERA_FACTURACION_CREATE_FACTURE_ON_PAGO_TXT == 1">Se emitirá el comprobante al cargar el txt <b v-if="confGlobal.value.FINANCIERA_FACTURACION_LOAD_TXT_ONLY_YEAR_ACTUAL == 1">Sólo si la referencia de pago es del año actual</b>, la fecha de emisión por default es la fecha de pago.
                                        <ul v-if="confGlobal.value.FINANCIERA_FACTURACION_MODIFY_EMISION_DATE == 1">
                                            <li>Puede cambiar la fecha de emisión si lo requiere <input type="date" v-model="facture_fecha_emision_txt"> <small>¡tenga cuidado en la consistencia de correlativo y fecha!</small></li>
                                        </ul>
                                    </li>
                                </ul>
                                <div class="card-body pt-6">
                                    <div class="mb-4">
                                        <a href="/formats/txtupdatepagos.txt" target="_new" class="btn btn-rose btn-ico"><span class="mr-2">Descargar formato de ejemplo</span>
                                            <BaseIcon :path="mdiArrowDownBold" />
                                        </a>
                                    </div>
                                    <div class="mb-4">
                                        <label>
                                            <input type="file" id="fileOrder" ref="fileOrder" v-on:change="handleFileUploadArchivo" accept=".TXT, .txt" class="w-full input-file input-file-slate" />
                                        </label>
                                    </div>
                                    <div>
                                        <button v-on:click="eventSubirArchivo('/payementOrder/importArchivo')" class="btn btn-rose">Subir</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <span @click="showCrearOrden=!showCrearOrden">[ +  Crear órdenes de pago]</span> -->
                        <!-- Crear órdenes de pago pensión y matrícula -->
                        <div class="tab-card tab-light mb-4">
                            <input class="tab-input" id="tab-crearOrder" type="checkbox">
                            <label @click="showCrearOrden = !showCrearOrden" class="tab-label ico-checkbox" for="tab-crearOrder">
                                <div>
                                    <span>
                                        <BaseIcon :path="mdiCashPlus" :size="24" class="mr-3 " />
                                        Crear órdenes de pago pensión, matrícula
                                    </span>
                                </div>

                            </label>
                            <div v-if="showCrearOrden" class="tab-content p-3">

                                <div class="mb-3">
                                    <ul>
                                        <li>Son {{ students.length }} alumnos activos no becados.</li>
                                        <li>En caso de generar matrícula del siguiente año, debe establecer a todos los alumnos nuevos que estudiaron este año a tipo antiguo, para establecer el costo del siguiente nivel si es que corresponde.</li>
                                        <li>Selecciones las opciones que desea crear órdenes de pago, el periodo 13 es
                                            la matrícula, si no se refleja los cambios de tarifa, actualice su navegador.</li>
                                        <li>Matrícula inicial: <b>{{ confGlobal.value.PRECIO_MATRICULA_INICIAL }}</b>, Matrícula primaria: <b>{{ confGlobal.value.PRECIO_MATRICULA_PRIMARIA }}</b>,
                                            Matrícula secundaria: <b>{{ confGlobal.value.PRECIO_MATRICULA_SECUNDARIA }}</b>, Pensión inicial:
                                            <b>{{ confGlobal.value.PRECIO_PENSION_INICIAL }}</b>, Pensión primaria: <b>{{ confGlobal.value.PRECIO_PENSION_PRIMARIA }}</b>
                                            , Pensión secundaria: <b>{{ confGlobal.value.PRECIO_PENSION_SECUNDARIA }}</b>
                                        </li>
                                        <!-- <BaseIcon
                                                    :path="mdiInformationOutline"
                                                    size="15"
                                                /> Puede subir archivos PDF, DOCX, PPT, XLSX, JPG, PNG, con un límite máximo de {{  confGlobal.value.RESOURCE_LIMIT_UPLOAD_FILE }} KB. El nombre del recurso deben ser distinto a otro para no reemplazar a otro existente. -->
                                    </ul>
                                </div>
                                <div v-if="order13 === true" class="mb-3">
                                    <div class="font-medium text-red-600 mb-3">
                                        Asegúrese de la orden de pago por matrícula sea del año correcto (si se matricula para este año o para el próximo año).
                                    </div>
                                    <div> Vencimiento de matrícula
                                        <input id="matriculaFVencimiento" name="matriculaFVencimiento" type="date" v-model="matriculaFVencimiento" autocomplete="off">
                                    </div>
                                </div>
                                <div class="flex flex-row w-full space-x-3 mb-4">
                                    <div class="flex items-center space-x-3">
                                        <label> Año </label>
                                        <!-- <BreezeInput id="inputname" type="text" class="w-[110px] lg:w-auto"
                                                v-model="orderAnio" /> -->
                                        <select class="rounded-lg" v-model="orderAnio">
                                            <option v-for="year in availableOrderYears" :key="year" :value="year">{{ year }}</option>
                                        </select>
                                    </div>
                                    <div class="flex items-center w-full space-x-3">
                                        <label> Alumno </label>
                                        <!-- <select class="mb-3 rounded-lg" v-model="idStudentOrder">
                                                <option value="0">Todos menos retirados y becados</option>
                                                <option v-if="allStudents.length" v-for="student in allStudents" :value="student.id">{{ student.num_doc }} {{ student.apellidos }} {{ student.nombres }}</option>
                                            </select> -->

                                        <!-- El id deve ser siempre value - doc: https://vue3-select-component.vercel.app/demo/custom-option-slot.html -->
                                        <VueSelect v-if="allStudents.length" class="select-search-light w-full" v-model="idStudentOrder" :options="allStudents" :get-option-label="(option) => `(${option.num_doc}) ${option.apellidos} ${option.nombres}`" placeholder="Todos los activos no becados o seleccione un estudiante" />
                                        <!-- <label class="ml-4 mr-4" for="list_alumno-choice">Alumno</label>
                                            <input v-model="idStudentOrder" type="search" class="mb-3 rounded-lg" placeholder="Alumnos" list="list-alumnos" id="list_alumno-choice" name="list_alumno-choice" style="width: 300px;">
                                            <datalist
                                                id="list-alumnos"
                                                name="list-alumnos"
                                                class="mb-3 rounded-lg">
                                                <option value="0">Todos menos retirados y becados</option>
                                                <option v-if="allStudents.length" v-for="student in allStudents" :value="student.id">{{ student.num_doc }} {{ student.apellidos }} {{ student.nombres }}</option>
                                            </datalist> -->
                                    </div>
                                </div>

                                <div class="mt-1 w-full label-clean xl:flex flex-row justify-between grid lg:grid-cols-6 sm:grid-cols-2 grid-cols-1">
                                    <div class="flex items-center">
                                        <input type="checkbox" id="chxmatricula" class="mr-2" v-model="order13" />
                                        <label for="chxmatricula">Matricula</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="checkbox" id="chxmarzo" class="mr-2" v-model="order03" />
                                        <label for="chxmarzo">Marzo</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="checkbox" id="chxabril" class="mr-2" v-model="order04" />
                                        <label for="chxabril">Abril</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="checkbox" id="chxmayo" class="mr-2" v-model="order05" />
                                        <label for="chxmayo">Mayo</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="checkbox" id="chxjunio" class="mr-2" v-model="order06" />
                                        <label for="chxjunio">Junio</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="checkbox" id="chxjulio" class="mr-2" v-model="order07" />
                                        <label for="chxjulio">Julio</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="checkbox" id="chxagosto" class="mr-2" v-model="order08" />
                                        <label for="chxagosto">Agosto</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="checkbox" id="chxsetiembre" class="mr-2" v-model="order09" />
                                        <label for="chxsetiembre">Setiembre</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="checkbox" id="chxoctubre" class="mr-2" v-model="order10" />
                                        <label for="chxoctubre">Octubre</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="checkbox" id="chxnoviembre" class="mr-2" v-model="order11" />
                                        <label for="chxnoviembre">Noviembre</label>
                                    </div>
                                    <div class="flex items-center">
                                        <input type="checkbox" id="chxdiciembre" class="mr-2" v-model="order12" />
                                        <label for="chxdiciembre">Diciembre</label>
                                    </div>

                                </div>
                                <div class="mt-4 block w-full">
                                    <span v-if="order13 && !matriculaFVencimiento" class="font-medium text-red-600">Debe asignar un año de matrícula</span>
                                    <span v-else-if="orderAnio < anioEscolar && idStudentOrder == 0" class="font-medium text-red-600">Para crear órdenes de años anteriores debe escoger un alumno</span>
                                    <BaseButton v-else :icon="mdiPlusCircle" color="info" icon-size="20" small label="Inicializar órdenes de pago" @click.once="iniciarOrdenPago()" />
                                    <div v-if="miniloading" class="inline-flex border-rose-400 h-5 w-5 animate-spin rounded-full border-4 border-t-white mr-2 ml-2" />

                                </div>
                            </div>
                        </div>

                        <!-- Crear órdenes de pago otros FINANCIERA_USE_ORDEN_PAGO_OTROS -->
                        <div v-if="(confGlobal.value.FINANCIERA_USE_ORDEN_PAGO_OTROS == 1)" class="tab-card tab-light">
                            <input class="tab-input" id="tab-crearOrderVarios" type="checkbox">
                            <label @click="showCrearOrdenVarios = !showCrearOrdenVarios" class="tab-label ico-checkbox" for="tab-crearOrderVarios">
                                <div>
                                    <span>
                                        <BaseIcon :path="mdiCashPlus" :size="24" class="mr-3 " />
                                        Crear órdenes de pago de tipo varios
                                    </span>
                                </div>

                            </label>
                            <div v-if="showCrearOrdenVarios" class="tab-content p-3">
                                <div class="mb-3">
                                    <ul>
                                        <li>Aquí puede generar otros tipo de órdenes, por ejemplo uniformes, libros, pagos a cuenta u otros seguimiento de pagos.</li>
                                    </ul>
                                </div>
                                <div class="lg:min-w-[400px] overflow-x-auto min-h-[290px]">
                                    <div class="grid grid-cols-1 lg:flex flex-row items-center gap-4 mb-4">
                                        <div class="basis-1/2">
                                            <label class="block mb-2"> Alumno </label>
                                            <!-- <select class="w-full min-w-[200px] border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm mt-1" v-model="idStudentOrder">
                                                    <option value="0">Seleccionar estudiante</option>
                                                    <option v-if="allStudents.length" v-for="student in allStudents" :value="student.id">{{ student.num_doc }} {{ student.apellidos }} {{ student.nombres }}</option>
                                                </select> -->

                                            <!-- El id deve ser siempre value - doc: https://vue3-select-component.vercel.app/demo/custom-option-slot.html -->
                                            <VueSelect v-if="allStudents.length" class="w-full select-search-light select-h-220" v-model="idStudentOrder" :options="allStudents" :get-option-label="(option) => `(${option.num_doc}) ${option.apellidos} ${option.nombres}`" placeholder="Seleccionar estudiante" />
                                        </div>

                                        <!-- <label class="ml-4 mr-4" for="list_alumno-choice">Alumno</label>
                                            <input v-model="idStudentOrder" type="search" class="mb-3 rounded-lg" placeholder="Alumnos" list="list-alumnos" id="list_alumno-choice" name="list_alumno-choice" style="width: 300px;">
                                            <datalist
                                                id="list-alumnos"
                                                name="list-alumnos"
                                                class="mb-3 rounded-lg">
                                                <option value="0">Todos menos retirados y becados</option>
                                                <option v-if="allStudents.length" v-for="student in allStudents" :value="student.id">{{ student.num_doc }} {{ student.apellidos }} {{ student.nombres }}</option>
                                            </datalist> -->

                                        <div class="basis-1/4">
                                            <label for="fechaEmision" class="block mb-2">Fecha emisión </label>
                                            <input id="fechaEmision" name="fechaEmision" type="date" class="w-full" v-model="fechaEmision" autocomplete="off">
                                        </div>
                                        <div class="basis-1/4">
                                            <label for="fechaVencimiento" class="block mb-2">Fecha Vencimiento </label>
                                            <input id="fechaVencimiento" name="fechaVencimiento" type="date" class="w-full" v-model="fechaVencimiento" autocomplete="off">
                                        </div>



                                        <!-- label class="mr-4"> Año </label>
                                            
                                            <select class="mb-3 rounded-lg" v-model="orderAnio">
                                                <option :value="parseInt(anioEscolar)-3">{{ parseInt(anioEscolar)-3 }}</option>
                                                <option :value="parseInt(anioEscolar)-2">{{ parseInt(anioEscolar)-2 }}</option>
                                                <option :value="parseInt(anioEscolar)-1">{{ parseInt(anioEscolar)-1 }}</option>
                                                <option :value="anioEscolar">{{ anioEscolar }}</option>
                                                <option :value="parseInt(anioEscolar)+1">{{ parseInt(anioEscolar)+1 }}</option>
                                            </select> -->
                                    </div>
                                    <div class="grid grid-cols-1 lg:flex flex-row items-center mb-4 gap-4 pb-4 xl:pb-2">
                                        <div class="basis-1/4">
                                            <label for="tipodeorder" class="block mb-2">Tipo de orden</label>
                                            <select id="tipodeorder" @click="listarOrdenPago()" class="w-full" v-model="tipoDeOrder">
                                                <option value="0">Otro</option>
                                                <option value="1">Pago a cuenta</option>
                                            </select>
                                        </div>
                                        <div v-if="tipoDeOrder == 1 && idStudentOrder > 0" class="basis-1/4">
                                            <label for="tipodeorder" class="block mb-2">Orden de origen</label>
                                            <select id="tipodeorder" class="w-full" v-model="idOrderOrigen">
                                                <option value="0">Escoger orden a descontar</option>
                                                <option v-if="arrayOrdenPago.length" v-for="order in arrayOrdenPago" :value="order.id">{{ order.label + ' S/ ' + order.total_ttc }}</option>
                                            </select>
                                        </div>
                                        <div class="basis-1/4">
                                            <!-- <label for="orderVariosLabel" class="block mb-2">Etiqueta/Referencia </label>
                                                <input id="orderVariosLabel" name="orderVariosLabel" type="text" class="w-full " v-model="orderVariosLabel" autocomplete="off"> -->
                                            <label for="orderVariosLabel" class="block mb-2">Etiqueta/Referencia </label>
                                            <input v-model="orderVariosLabel" type="search" class="w-full" placeholder="" list="list-ref-otros" id="orderVariosLabel" name="orderVariosLabel" autocomplete="off">
                                            <datalist id="list-ref-otros" name="list-ref-otros" class="mb-3 rounded-md">
                                                <option value="VACACIONAL">VACACIONAL</option>
                                                <option value="CIRCULO VERANO">CIRCULO VERANO</option>
                                                <option value="CERTIFICADO DE ESTUDIOS">CERTIFICADO DE ESTUDIOS</option>
                                                <option value="CONSTANCIA DE MATRICULA">CONSTANCIA DE MATRICULA</option>
                                                <option value="CONSTANCIA DE NO ADEUDO">CONSTANCIA DE NO ADEUDO</option>
                                                <option value="CONSTANCIA DE NOTAS">CONSTANCIA DE NOTAS</option>
                                                <option value="CONSTANCIA DE TERCIO SUPERIOR">CONSTANCIA DE TERCIO SUPERIOR</option>
                                                <option value="CONSTANCIA DE QUINTO SUPERIOR">CONSTANCIA DE QUINTO SUPERIOR</option>
                                                <option value="CONSTANCIA DE DECIMO SUPERIOR">CONSTANCIA DE DECIMO SUPERIOR</option>
                                            </datalist>
                                        </div>

                                        <div class="basis-1/4">
                                            <label for="orderVariosAmount" class="block mb-2">Monto </label>
                                            <input id="orderVariosAmount" name="orderVariosAmount" type="number" class="w-full " v-model="orderVariosAmount" autocomplete="off">
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <span v-if="errorOrderVarios" class="font-medium text-red-600">Debe ingresar los campos requeridos</span>
                                    <span v-if="tipoDeOrder == 1 && idOrderOrigen <= 0" class="font-medium text-red-600">Si es un pago a cuenta, debe escoger una orden de origen del estudiante para el descuento de esa orden</span>
                                    <BaseButton v-else :icon="mdiPlusCircle" color="info" icon-size="20" small label="Registrar orden de pago" @click.once="iniciarOrdenPagoVarios()" />
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </template> 
            <template v-else-if="tab == 3">
                <!-- Configuración -->
                <div class="shadow-lg border rounded-md p-4 bg-white">
                    <!--<div v-for="user in users" :key="user.id">
                            <Link :href="`/users/${user.id}`">
                                {{ user.user}}
                            </Link>
                            <div>{{ user.name}}</div>
                        </div>-->

                    <div class="tab-horizontal">
                        <button @click="(subtab = 0)" class="tab-horizontal-btn" :class="[subtab == 0 ? 'active' : 'inactivo']">
                            <BaseIcon :path="mdiChevronRight" :size="16" class="" />
                            <span>Opciones Avanzadas</span>
                        </button>
                        <button @click="(subtab = 1)" class="tab-horizontal-btn" :class="[subtab == 1 ? 'active' : 'inactivo']">
                            <BaseIcon :path="mdiChevronRight" :size="16" class="" />
                            <span>Parámetros</span>
                        </button>
                        <button @click="(subtab = 2)" class="tab-horizontal-btn" :class="[subtab == 2 ? 'active' : 'inactivo']">
                            <BaseIcon :path="mdiChevronRight" :size="16" class="" />
                            <span>Tarea Anual</span>
                        </button>
                    </div>


                    <div class="grid grid-cols-1" v-if="subtab == 0">
                        <div class="rounded-lg flex-col dark:bg-slate-900/70 bg-white flex">
                            <ol class="mt-4">
                                <li>
                                    <p class="mt-4">Permitir actualizar historia del estudiante desde su ficha (esto si no lo establecieron antes de ejecutar la tarea anual de guardar historia)</p>
                                    <BaseButtons type="justify-start" no-wrap>
                                        <BaseButton small @click="(ejecutarConfirm['modifystoryfromficha'] = 1)" :label="(confGlobal.value.STUDENT_MODIFY_STORY_FROM_FICHA == 1 ? 'Desactivar la actualización de historia desde la ficha' : 'Activar la actualización de historia desde la ficha')" :color="(confGlobal.value.STUDENT_MODIFY_STORY_FROM_FICHA == 1 ? 'warning' : 'info')" whitespaceNormal wFull/>
                                        <BaseButton v-if="ejecutarConfirm['modifystoryfromficha'] == 1" color="warning" label="Confirmar" small @click="(ejecutar('modifystoryfromficha'), (ejecutarConfirm['modifystoryfromficha'] = 0))" />
                                    </BaseButtons>
                                </li>
                                <li>
                                    <p class="mt-4">Habilitar Modalidad Vacacional Verano</p>
                                    <BaseButtons type="justify-start" no-wrap>
                                        <BaseButton small @click="(ejecutarConfirm['modalidadvacacional'] = 1)" :label="(confGlobal.value.VACACIONAL_MODE_ACTIVE == 1 ? 'Desactivar modalidad Vacacional' : 'Activar modalidad Vacacional')" :color="(confGlobal.value.VACACIONAL_MODE_ACTIVE == 1 ? 'warning' : 'info')" whitespaceNormal wFull/>
                                        <BaseButton v-if="ejecutarConfirm['modalidadvacacional'] == 1" color="warning" label="Confirmar" small @click="(ejecutar('modalidadvacacional'), (ejecutarConfirm['modalidadvacacional'] = 0))" />
                                    </BaseButtons>
                                </li>
                                <li>
                                    <p class="mt-4">Registro obligatorio de apoderado al crear un estudiante</p>
                                    <BaseButtons type="justify-start" no-wrap>
                                        <BaseButton small @click="(ejecutarConfirm['validarcontactmandatory'] = 1)" :label="(confGlobal.value.STUDENT_CREATE_WITH_CONTACT_IS_MANDATORY == 1 ? 'Contacto/apoderado obligatorio activado' : 'Contacto/apoderado obligatorio desactivado')" :color="(confGlobal.value.STUDENT_CREATE_WITH_CONTACT_IS_MANDATORY == 1 ? 'info' : 'warning')" whitespaceNormal wFull/>
                                        <BaseButton v-if="ejecutarConfirm['validarcontactmandatory'] == 1" color="warning" label="Confirmar" small @click="(ejecutar('', 'STUDENT_CREATE_WITH_CONTACT_IS_MANDATORY'), (ejecutarConfirm['validarcontactmandatory'] = 0))" />
                                    </BaseButtons>
                                </li>
                            </ol>
                        </div>
                        <!-- lg:justify-end -->
                    </div>
                    <div class="grid grid-cols-1" v-if="subtab == 1">
                        <div class="col-span-1">
                            <div class="mt-4 mb-3">
                                <ul>
                                    <li>Se muestran las tarifas de matrícula y pensión por defecto.</li>
                                    <li>Debe establecer los montos actuales antes de inicializar órdenes de pago para que estas se creen con la tarifa actual.</li>
                                    <li>Si hay dos empresas debe asignar el nivel educativo con la entidad que corresponde en panel de configuración, niveles (sólo se toma en cuenta el nivel padre)</li>
                                </ul>
                            </div>
                            <div v-if="pinSecurity != confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY" class="my-5">
                                    <p class="text-sm lg:inline-block mr-4 mb-3">Para realizar cambios ingrese el Pin de seguridad (No se verá lo que escribe) </p>
                                    <input id="pin_security" name="pin_security" type="text" class="text-transparent lg:w-auto w-full" v-model="pinSecurity" autocomplete="off" title="Si selecciona el campo podrá ver lo que escribió">
                                </div>
                            <div>
                                <BreezeValidationErrors class="mb-4" />
                                <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                    <CardBox is-form @submit.prevent="tarifaSubmit">
                                        <!-- <FormField label="Avatar" help="Max 500kb">
                                            <FormFilePicker label="Upload" />
                                        </FormField> -->

                                        <!-- <FormField label="Matrícula general" help="">
                                            <FormControl
                                            v-model="tarifaForm.matriculaGeneral"
                                            :icon="mdiCashPlus"
                                            type="number"
                                            name="matriculaGeneral"
                                            required
                                            autocomplete="matriculaGeneral"
                                            :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)"
                                            />
                                        </FormField> -->
                                        <FormField label="Matrícula inicial" help="">
                                            <FormControl v-model="tarifaForm.matriculaInicial" :icon="mdiCashPlus" type="number" name="matriculaInicial" required autocomplete="matriculaInicial" :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)" />
                                        </FormField>
                                        <FormField label="Matrícula primaria" help="">
                                            <FormControl v-model="tarifaForm.matriculaPrimaria" :icon="mdiCashPlus" type="number" name="matriculaPrimaria" required autocomplete="matriculaPrimaria" :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)" />
                                        </FormField>
                                        <FormField label="Matrícula secundaria" help="">
                                            <FormControl v-model="tarifaForm.matriculaSecundaria" :icon="mdiCashPlus" type="number" name="matriculaSecundaria" required autocomplete="matriculaSecundaria" :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)" />
                                        </FormField>

                                        <FormField label="Pensión Inicial" help="">
                                            <FormControl v-model="tarifaForm.pensionInicial" :icon="mdiCashPlus" type="number" name="pensionInicial" required autocomplete="pensionInicial" :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)" />
                                        </FormField>
                                        <FormField label="Pensión Primaria" help="">
                                            <FormControl v-model="tarifaForm.pensionPrimaria" :icon="mdiCashPlus" type="number" name="pensionPrimaria" required autocomplete="pensionPrimaria" :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)" />
                                        </FormField>
                                        <FormField label="Pensión Secundaria" help="">
                                            <FormControl v-model="tarifaForm.pensionSecundaria" :icon="mdiCashPlus" type="number" name="pensionSecundaria" required autocomplete="pensionSecundaria" :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)" />
                                        </FormField>

                                        <template #footer>
                                            <BaseButtons>
                                                <BaseButton v-if="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? true : false)" color="info" type="submit" label="Guardar" />
                                                <!-- <BaseButton color="info" label="Options" outline /> -->
                                            </BaseButtons>
                                        </template>
                                    </CardBox>

                                    <CardBox is-form @submit.prevent="otherConfSubmit">
                                        <!-- <FormField
                                            label="Current password"
                                            help="Ingresar password actual"
                                        >
                                            <FormControl
                                            v-model="passwordForm.password_current"
                                            :icon="mdiAsterisk"
                                            name="password_current"
                                            type="password"
                                            required
                                            autocomplete="current-password"
                                            />
                                        </FormField>

                                        <BaseDivider /> -->

                                        <FormField label="Automatizar Acceso" help="Actualizar acceso del alumno desde txt de pagos">
                                            <FormControl v-model="otherConfForm.automatizarAcceso" :icon="mdiCog" name="automatizarAcceso" type="yesno" required autocomplete="automatizarAcceso" :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)" />
                                        </FormField>

                                        <FormField label="Día límite para desactivar accesos" help="Luego de este día, al subir los txt de pagos se desactivarán los usuarios">
                                            <FormControl v-model="otherConfForm.diaValidarAccesoPago" :icon="mdiCog" name="diaValidarAccesoPago" type="number" required autocomplete="diaValidarAccesoPago" :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)" />
                                        </FormField>

                                        <FormField label="Fecha de Bloqueo" help="Fecha de bloqueo recaudo banco en txt de altas o bajas, sin espacios o carácteres especiales (ejem. 20301231)">
                                            <FormControl v-model="otherConfForm.fechaBloqueo" :icon="mdiCog" name="fechaBloqueo" type="text" required autocomplete="fechaBloqueo" :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)" />
                                        </FormField>

                                        <FormField label="Crear orden de pago al crear estudiante" help="Al crear un estudiante mostrar la opción de crear sus órdenes de pago (matrícula, pensión)">
                                            <FormControl v-model="otherConfForm.crearOrdenPagoEstudiante" :icon="mdiCog" name="crearOrdenPagoEstudiante" type="yesno" required autocomplete="crearOrdenPagoEstudiante" :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)" />
                                        </FormField>

                                        <FormField label="Colaborador, penalidad descuento por minuto" help="Asistencia, penalidad descuento por minuto (tardanza y salida temprano)">
                                            <FormControl v-model="otherConfForm.colaboradorPenalidadDescuentoMinuto" :icon="mdiCog" name="colaboradorPenalidadDescuentoMinuto" type="text" required autocomplete="colaboradorPenalidadDescuentoMinuto" :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)" />
                                        </FormField>

                                        <FormField v-if="confGlobal.value.FINANCIERA_USE_MORA == 1" label="Pensión, mora por día de atraso" help="Cobranzas, se sumará el monto desde la fecha de vencimiento hasta la actual.">
                                            <FormControl v-model="otherConfForm.pensionmoraxdia" :icon="mdiCog" name="pensionmoraxdia" type="text" required autocomplete="pensionmoraxdia" :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)" />
                                        </FormField>

                                        <FormField label="Mensaje por defecto de cobranza" help="Cobranzas, se puede usar las palabras reservadas: __APODERADO_NOMBRE__, __REF_DEUDAS__, __TOT_PENSION__, __TOT_MORA__, __TOT_OTROS__, __TOT_ACTUAL__">
                                            <FormControl v-model="otherConfForm.cobranzamensaje" :icon="mdiCog" name="cobranzamensaje" type="textarea" required autocomplete="cobranzamensaje" :readonly="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? false : true)" />
                                        </FormField>

                                        <template #footer>
                                            <BaseButtons>
                                                <BaseButton v-if="(pinSecurity == confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? true : false)" type="submit" color="info" label="Guardar" />
                                                <!-- <BaseButton color="info" label="Options" outline /> -->
                                            </BaseButtons>
                                        </template>
                                    </CardBox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-1" v-if="subtab == 2">
                        <div class="col-span-1 pt-4">

                            <div class="mb-2 p-2 border bg-gray-50 rounded-md">
                                <h2><span class="text-red-600">¡CUIDADO! </span>Procesos para inicializar un nuevo año escolar una vez que se realicen los pasos; <span class="font-bold">no hay marcha atrás</span> y si realiza los pasos por error no habrá nada que podamos hacer.</h2>
                            </div>
                            <div v-if="pinSecurity != confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY" class="my-5">
                                <p class="text-sm mb-3 lg:inline-block mr-4">Para realizar cambios ingrese el Pin de seguridad (no se verá lo que escribe) </p>
                                <input id="pin_security" name="pin_security" type="text" class="text-transparent lg:w-auto w-full" v-model="pinSecurity" autocomplete="off" title="Si selecciona el campo podrá ver lo que escribió">
                            </div>

                            <CardBox :class="pinSecurity != confGlobal.value.FINANCIERA_PIN_SECURITY_MODIFY ? 'pointer-events-none' : ''" has-table>
                                <!-- lg:justify-end -->

                                <ol>
                                    <li class="mb-3">
                                        <p class="mb-3">Esto creará o actualizará la historia del estudiante activo del año actual (se recomienda que todas las aulas del estudiante deben ser las correctas)</p>

                                        <!-- <button class="btn btn-blue w-full lg:w-auto">
                                                Para empezar a matricular un nuevo año escolar se debe establecer a todos los estudiantes nuevos como
                                            </button> -->
                                        <BaseButtons type="justify-start" >
                                            <BaseButton color="info" :label="'Ejecutar Historia ' + anioEscolar + ' anual antiguos y nuevos'" small @click="(ejecutarConfirm['storyantiguos'] = 1)"  whitespaceNormal wFull/>
                                            <BaseButton v-if="ejecutarConfirm['storyantiguos'] == 1" color="warning" label="Confirmar" small @click="(crearStory(1), (ejecutarConfirm['storyantiguos'] = 0))" />
                                        </BaseButtons>

                                    </li>
                                    <li class="mb-3">
                                        <p class="mb-3">Para empezar a matricular un nuevo año escolar se debe establecer a todos los estudiantes nuevos como antiguos (los únicos nuevos serán los matriculados a partir de ahora).</p>
                                        <BaseButtons type="justify-start" >

                                            <BaseButton color="info" label="Establecer todos los estudiantes nuevos a antiguos" small @click="(ejecutarConfirm['allantiguos'] = 1)"  whitespaceNormal wFull/>
                                            <BaseButton v-if="ejecutarConfirm['allantiguos'] >= 1" color="warning" label="Confirmar" small @click="(ejecutarConfirm['allantiguos'] = 2)" />

                                            <BaseButton v-if="ejecutarConfirm['allantiguos'] >= 2" color="danger" label="Re Confirmar" small @click="(ejecutarConfirm['allantiguos'] = 3)" />

                                            <BaseButton v-if="ejecutarConfirm['allantiguos'] == 3" color="warning" label="Todos serán antiguos" small @click="(ejecutar('allantiguos'), (ejecutarConfirm['allantiguos'] = 0))" />

                                        </BaseButtons>
                                    </li>
                                    <!-- <li>3. Esto creará la historia del estudiante nuevo al siguiente año escolar o actualizará su historia (opcional)</li>
                                            <BaseButtons type="justify-start" no-wrap>
                                                <BaseButton color="info" :label="'Ejecutar Historia ' + (parseInt(anioEscolar) + 1) + ' anual nuevos'" small @click="(ejecutarConfirm['storynuevos'] = 1)" />
                                                <BaseButton v-if="ejecutarConfirm['storynuevos'] == 1" color="warning" label="Confirmar" small @click="(crearStory(0), (ejecutarConfirm['storynuevos'] = 0))" />
                                            </BaseButtons>
                                            <br> -->
                                    <li class="mb-3">
                                        <p class="mb-3">Esto se realizará al finalizar el año lectivo. Todos los estudiantes antiguos activos se cambiarán a promovidos (los de quinto de secundaria a egresados)</p>
                                        
                                        <BaseButtons type="justify-start">
                                            <BaseButton color="info" label="Establecer todos los estudiantes activos como promovidos (los de quinto de secundaria a egresados)" small @click="(ejecutarConfirm['allpromovidos'] = 1)" whitespaceNormal wFull/>

                                            <BaseButton v-if="ejecutarConfirm['allpromovidos'] == 1" color="warning" label="Confirmar" small @click="(ejecutar('allpromovidos'), (ejecutarConfirm['allpromovidos'] = 0))" />

                                        </BaseButtons>
                                    </li>
                                    <li class="mb-3">
                                        <p class="mb-3">Aperturar ciclos académicos del año actual (Bimestres {{ anioActual }})</p>
                                        <BaseButtons type="justify-start">
                                            <BaseButton color="info" :label="'Aperturar ciclo académico actual ' + (parseInt(anioActual))" small @click="(ejecutarConfirm['aperturarciclos'] = 1)"  whitespaceNormal wFull/>

                                            <BaseButton v-if="ejecutarConfirm['aperturarciclos'] == 1" color="warning" label="Confirmar" small @click="(ejecutar('aperturarciclos'), (ejecutarConfirm['aperturarciclos'] = 0))" />

                                        </BaseButtons>
                                    </li>

                                    <li class="mb-3">
                                        <p class="mb-3">Cambiar año lectivo de {{ anioEscolar }} a {{ anioActual }}</p>
                                        <BaseButtons type="justify-start">
                                            <BaseButton color="info" :label="'Establecer año lectivo ' + (parseInt(anioActual))" small @click="(ejecutarConfirm['estableceraniolectivo'] = 1)"  whitespaceNormal wFull/>

                                            <BaseButton v-if="ejecutarConfirm['estableceraniolectivo'] == 1" color="warning" label="Confirmar" small @click="(ejecutar('estableceraniolectivo'), (ejecutarConfirm['estableceraniolectivo'] = 0))"/>

                                        </BaseButtons>
                                    </li>
                                    <!-- <li>7. Permitir actualizar historia del estudiante desde su ficha (Historia)</li>
                                            <BaseButtons type="justify-start" no-wrap>
                                                <BaseButton color="info" :label="(confGlobal.value.STUDENT_MODIFY_STORY_FROM_FICHA == 1 ? 'Desactivar la actualización de historia desde la ficha' :'Activar la actualización de historia desde la ficha')" small @click="(ejecutarConfirm['modifystoryfromficha'] = 1)" />

                                                <BaseButton v-if="ejecutarConfirm['modifystoryfromficha'] == 1" color="warning" label="Confirmar" small @click="(ejecutar('modifystoryfromficha'), (ejecutarConfirm['estableceraniolectivo'] = 0))" />

                                            </BaseButtons> -->
                                </ol>
                            </CardBox>
                        </div>
                    </div>

                </div>
            </template>
            <!-- Deudores -->
            <template v-else-if="tab == 4">
                    <div class="shadow-lg border rounded-md p-4 bg-white">
                        <!--<div v-for="user in users" :key="user.id">
                                <Link :href="`/users/${user.id}`">
                                    {{ user.user}}
                                </Link>
                                <div>{{ user.name}}</div>
                            </div>-->
                        <div>
                            <div class="mb-0">
                                <div>
                                    <a href="#" class="group relative inline-block text-blue-500 underline hover:text-red-500 duration-300" @click="showAyuda['cobranzas'] = !showAyuda['cobranzas']">
                                        Ayuda
                                        <BaseIcon :path="mdiInformationOutline" size="15" />
                                    </a>
                                </div>
                                <div class="flex items-center justify-center">
                                    <input name="year" class="w-16 ml-3 rounded-lg" type="text" v-model="anioSearch" @change="listarDeudores()" :placeholder="confGlobal.value.CICLO_ANIO_ESCOLAR">
                                </div>
                                <div v-if="showAyuda['cobranzas']">

                                    <li>Sólo se muestran los deudores del año escolar actual, puede cambiar el año si lo requiere.</li>
                                    <li>El número de orden puede variar en caso que halla menos o más deudores de un día a otro.</li>
                                    <li>El contenido del mensaje es el inicio para que usted agregue más contenido si lo considera.</li>
                                    <li>Para enviar mensaje por Whatsapp desde la computadora debe tener instalado el Whatsapp de escritorio.</li>
                                    <li>Se muestra el código de aula para mantener el orden Ascendente. El orden por defecto es de Aula sección -> apellidos -> nombres.</li>
                                    <li>El sufijo Ret. quiere decir que el estudiante está retirado.</li>
                                </div>

                            </div>

                        </div>

                        <CardBox v-if="arrayListDeudores.length" class="mt-4" has-table>
                            <!-- Tablesingle opciones: checkable -->
                            <div class="w-full overflow-x-auto relative">
                                <TableAdvanced modulo="cobranzas" modulos="Deudores" :data="arrayListDeudores" :fields="arrayListDeudoresCol" ruta="payementOrder" exporteable showIndex :userParam="userParamDeudores" /><!-- showTotales propiedad para PDF -> isSearchYear no se usa ya que no es una funcion index -->
                            </div>
                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentEmpty />
                        </CardBox>
                    </div>
            </template>
            <!-- Contabilidad -->
            <template v-else-if="tab == 5">
                    <div class="shadow-lg border rounded-md p-6 bg-white">
                        <!-- Mostrar Resumen del total de comprobantes y total facturado, total anulado y filtrado por Periodos -->
                        <BaseButton color="info" :icon="mdiCloud" label="NubeCont" small  whitespaceNormal wFull href="https://servcomit.nubecont.com/login" target="_blank"/>
                        <!--<div v-for="user in users" :key="user.id">
                                <Link :href="`/users/${user.id}`">
                                    {{ user.user}}
                                </Link>
                                <div>{{ user.name}}</div>
                            </div>-->
                </div>
            </template>
            <!-- Facturación -->
            <template v-else-if="tab == 6">
                    <div class="shadow-lg border rounded-md p-4 bg-white">
                        <!--<div v-for="user in users" :key="user.id">
                                <Link :href="`/users/${user.id}`">
                                    {{ user.user}}
                                </Link>
                                <div>{{ user.name}}</div>
                            </div>-->

                        <div class="mb-2">
                            <a href="#" class="group relative inline-block text-blue-500 underline hover:text-red-500 duration-300" @click="showAyuda['facture'] = !showAyuda['facture']">
                                Ayuda
                                <BaseIcon :path="mdiInformationOutline" size="15" />
                            </a>
                            <div v-if="showAyuda['facture']">
                                <li>El año de consulta actual es por default, si requiere de años anteriores cambiar el año.</li>
                                <li>Las boletas de venta electrónica se envían automáticamente a Sunat por resumen diario al día siguiente de su emisión.</li>
                                <li>Para dar de baja un comprobante, este debe estar aceptado por Sunat previamente.</li>

                            </div>
                            <!-- <li>Verificar que los totales con su decimales sean correctos</li> -->
                        </div>

                        <CardBox v-if="arrayFacture && arrayFacture.length" class="mb-6" has-table>
                            <!-- Tablesingle opciones: checkable -->
                            <div class="w-full overflow-x-auto relative">
                                <TableAdvanced modulo="facture" modulos="Facturas/Boletas" :data="arrayFacture" :fields="arrayFactureCol" ruta="facture" :exporteable="(isAdmin ? true : false)" searchAdvance :checkable="(isAdmin ? true : false)" isSearchYear :userParam="userParamFacture" :debugInertia="confGlobal.value.DEBUG_DISABLE_REFRESH_INERTIA == 1" /><!-- showTotales propiedad para PDF-->
                            </div>
                        </CardBox>
                        <CardBox v-else>
                            <CardBoxComponentEmpty />
                        </CardBox>
                    </div>
            </template>
            <!-- <template v-else-if="tab==4">
                    <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                        <div class="p-6 bg-white border-b border-gray-200">
                            
                            <div>
                                <Link :href="route('file-create', {'origin_type': 'file_resourceforcourse'})">
                                    <BaseButton
                                        color="info"
                                        :icon="mdiPlusCircle"
                                        small
                                        label=" Nuevo"
                                        class="float-right"
                                    />
                                </Link>
                            </div>
                            
                            <CardBox v-if="arrayFileResources.length" class="mb-6" has-table>
                               
                                <div class="w-full overflow-x-auto relative">
                                    <TableAdvanced modulo="Documento" modulos="Recursos de estudio" :data="arrayFileResources" :fields="arrayFileResourcesCol" ruta="file"
                                        updateable/>
                                </div>
                            </CardBox>
                            <CardBox v-else>
                                <CardBoxComponentLoad />
                            </CardBox>
                        </div>
                </div>
            </template> -->
        </div>
    </BreezeAuthenticatedLayout>
</template>
<style lang="css" scoped>
/* :deep(.vue-select .custom-value) {
    display: flex;
    align-items: center;
    gap: 6px;
    }

    :deep(.vue-select .custom-option) {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #171717;
    font-weight: 500;
    font-size: 16px;
    }

    :deep(.vue-select .custom-option small) {
    color: #525252;
    font-weight: 500;
    font-size: 14px;
    } */</style>
